/* tslint:disable */
/* eslint-disable */
/**
 * Jobs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Unix timestamp representing a fixed time point.
 * @export
 * @interface AbsoluteTimePoint
 */
export interface AbsoluteTimePoint {
    /**
     * 
     * @type {string}
     * @memberof AbsoluteTimePoint
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsoluteTimePoint
     */
    'type'?: AbsoluteTimePointTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AbsoluteTimePoint
     */
    'timestamp_seconds': number;
}

/**
    * @export
    * @enum {string}
    */
export enum AbsoluteTimePointTypeEnum {
    TIME_POINT_ABSOLUTE = 'time_point_absolute'
}

/**
 * 
 * @export
 * @interface AndConditionInput
 */
export interface AndConditionInput {
    /**
     * 
     * @type {string}
     * @memberof AndConditionInput
     */
    'type'?: AndConditionInputTypeEnum;
    /**
     * 
     * @type {Array<AndConditionInputConditionsInner>}
     * @memberof AndConditionInput
     */
    'conditions'?: Array<AndConditionInputConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum AndConditionInputTypeEnum {
    AND = 'and'
}

/**
 * @type AndConditionInputConditionsInner
 * @export
 */
export type AndConditionInputConditionsInner = { type: 'and' } & AndConditionInput | { type: 'contains' } & ContainsConditionInput | { type: 'eq' } & EqualsConditionInput | { type: 'gt' } & GreaterThanConditionInput | { type: 'gte' } & GreaterThanOrEqualsConditionInput | { type: 'is_in' } & IsInConditionInput | { type: 'is_null' } & IsNullConditionInput | { type: 'lt' } & LessThanConditionInput | { type: 'lte' } & LessThanOrEqualsConditionInput | { type: 'not' } & NotConditionInput | { type: 'or' } & OrConditionInput;

/**
 * 
 * @export
 * @interface AndConditionOutput
 */
export interface AndConditionOutput {
    /**
     * 
     * @type {string}
     * @memberof AndConditionOutput
     */
    'type'?: AndConditionOutputTypeEnum;
    /**
     * 
     * @type {Array<AndConditionOutputConditionsInner>}
     * @memberof AndConditionOutput
     */
    'conditions'?: Array<AndConditionOutputConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum AndConditionOutputTypeEnum {
    AND = 'and'
}

/**
 * @type AndConditionOutputConditionsInner
 * @export
 */
export type AndConditionOutputConditionsInner = { type: 'and' } & AndConditionOutput | { type: 'contains' } & ContainsConditionOutput | { type: 'eq' } & EqualsConditionOutput | { type: 'gt' } & GreaterThanConditionOutput | { type: 'gte' } & GreaterThanOrEqualsConditionOutput | { type: 'is_in' } & IsInConditionOutput | { type: 'is_null' } & IsNullConditionOutput | { type: 'lt' } & LessThanConditionOutput | { type: 'lte' } & LessThanOrEqualsConditionOutput | { type: 'not' } & NotConditionOutput | { type: 'or' } & OrConditionOutput;

/**
 * 
 * @export
 * @interface AssembleDatasetJob
 */
export interface AssembleDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof AssembleDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'status': AssembleDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof AssembleDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssembleDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJob
     */
    'type': AssembleDatasetJobTypeEnum;
    /**
     * 
     * @type {CreateDatasetFromHistoryOutput}
     * @memberof AssembleDatasetJob
     */
    'request': CreateDatasetFromHistoryOutput;
    /**
     * 
     * @type {AssembleDatasetJobResponse}
     * @memberof AssembleDatasetJob
     */
    'response'?: AssembleDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AssembleDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum AssembleDatasetJobTypeEnum {
    ASSEMBLE = 'assemble'
}

/**
 * 
 * @export
 * @interface AssembleDatasetJobCreation
 */
export interface AssembleDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJobCreation
     */
    'type': AssembleDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {CreateDatasetFromHistoryInput}
     * @memberof AssembleDatasetJobCreation
     */
    'request': CreateDatasetFromHistoryInput;
    /**
     * 
     * @type {AssembleDatasetJobResponse}
     * @memberof AssembleDatasetJobCreation
     */
    'response'?: AssembleDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AssembleDatasetJobCreationTypeEnum {
    ASSEMBLE = 'assemble'
}

/**
 * 
 * @export
 * @interface AssembleDatasetJobResponse
 */
export interface AssembleDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof AssembleDatasetJobResponse
     */
    'dataset_id': string;
}
/**
 * 
 * @export
 * @interface AssembleSimulationDatasetJob
 */
export interface AssembleSimulationDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof AssembleSimulationDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'status': AssembleSimulationDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof AssembleSimulationDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssembleSimulationDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJob
     */
    'type': AssembleSimulationDatasetJobTypeEnum;
    /**
     * 
     * @type {CreateSimulationDatasetOutput}
     * @memberof AssembleSimulationDatasetJob
     */
    'request': CreateSimulationDatasetOutput;
    /**
     * 
     * @type {AssembleSimulationDatasetJobResponse}
     * @memberof AssembleSimulationDatasetJob
     */
    'response'?: AssembleSimulationDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AssembleSimulationDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum AssembleSimulationDatasetJobTypeEnum {
    ASSEMBLE_SIMULATION = 'assemble_simulation'
}

/**
 * 
 * @export
 * @interface AssembleSimulationDatasetJobCreation
 */
export interface AssembleSimulationDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJobCreation
     */
    'type': AssembleSimulationDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {CreateSimulationDatasetInput}
     * @memberof AssembleSimulationDatasetJobCreation
     */
    'request': CreateSimulationDatasetInput;
    /**
     * 
     * @type {AssembleSimulationDatasetJobResponse}
     * @memberof AssembleSimulationDatasetJobCreation
     */
    'response'?: AssembleSimulationDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AssembleSimulationDatasetJobCreationTypeEnum {
    ASSEMBLE_SIMULATION = 'assemble_simulation'
}

/**
 * 
 * @export
 * @interface AssembleSimulationDatasetJobResponse
 */
export interface AssembleSimulationDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJobResponse
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJobResponse
     */
    'prefix': string;
    /**
     * 
     * @type {string}
     * @memberof AssembleSimulationDatasetJobResponse
     */
    'dataset_id'?: string | null;
}
/**
 * @type Body
 * @export
 */
export type Body = { type: 'assemble' } & AssembleDatasetJobCreation | { type: 'assemble_simulation' } & AssembleSimulationDatasetJobCreation | { type: 'create_job_source' } & CreateJobSourceFromJobRunDatasetJobCreation | { type: 'download' } & DownloadDatasetJobCreation | { type: 'duplicate' } & DuplicateDatasetJobCreation | { type: 'entity_upload' } & EntityUploadDatasetJobCreation | { type: 'event_upload' } & EventUploadDatasetJobCreation | { type: 'export_decisions' } & ExportDecisionsDatasetJobCreation | { type: 'history_export' } & HistoryExportDatasetJobCreation | { type: 'history_export_v3' } & HistoryExportV3DatasetJobCreation | { type: 'simulation_download' } & SimulationDownloadDatasetJobCreation | { type: 'simulation_failures' } & SimulationFailuresDatasetJobCreation;

/**
 * 
 * @export
 * @interface CompletedJobRunStatus
 */
export interface CompletedJobRunStatus {
    /**
     * 
     * @type {string}
     * @memberof CompletedJobRunStatus
     */
    'type': CompletedJobRunStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompletedJobRunStatus
     */
    'completed_at'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CompletedJobRunStatusTypeEnum {
    COMPLETED = 'completed'
}

/**
 * @type Condition
 * @export
 */
export type Condition = { type: 'and' } & AndConditionInput | { type: 'contains' } & ContainsConditionInput | { type: 'eq' } & EqualsConditionInput | { type: 'gt' } & GreaterThanConditionInput | { type: 'gte' } & GreaterThanOrEqualsConditionInput | { type: 'is_in' } & IsInConditionInput | { type: 'is_null' } & IsNullConditionInput | { type: 'lt' } & LessThanConditionInput | { type: 'lte' } & LessThanOrEqualsConditionInput | { type: 'not' } & NotConditionInput | { type: 'or' } & OrConditionInput;

/**
 * @type Condition1
 * @export
 */
export type Condition1 = { type: 'and' } & AndConditionOutput | { type: 'contains' } & ContainsConditionOutput | { type: 'eq' } & EqualsConditionOutput | { type: 'gt' } & GreaterThanConditionOutput | { type: 'gte' } & GreaterThanOrEqualsConditionOutput | { type: 'is_in' } & IsInConditionOutput | { type: 'is_null' } & IsNullConditionOutput | { type: 'lt' } & LessThanConditionOutput | { type: 'lte' } & LessThanOrEqualsConditionOutput | { type: 'not' } & NotConditionOutput | { type: 'or' } & OrConditionOutput;

/**
 * @type Configuration
 * @export
 */
export type UnionConfiguration = { type: 's3_bucket' } & S3BucketJobDestinationConfiguration | { type: 'sql' } & SQLJobDestinationConfiguration;

/**
 * @type Configuration1
 * @export
 */
export type Configuration1 = { type: 'dataset' } & DatasetJobSourceConfiguration | { type: 'entity' } & EntityJobSourceConfigurationOutput | { type: 's3_bucket_dataset' } & S3BucketDatasetSourceConfiguration | { type: 'sql' } & SQLJobSourceConfiguration;

/**
 * @type Configuration2
 * @export
 */
export type Configuration2 = { type: 'dataset' } & DatasetJobSourceConfiguration | { type: 'entity' } & EntityJobSourceConfigurationInput | { type: 's3_bucket_dataset' } & S3BucketDatasetSourceConfiguration | { type: 'sql' } & SQLJobSourceConfiguration;

/**
 * 
 * @export
 * @interface ContainsConditionInput
 */
export interface ContainsConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof ContainsConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof ContainsConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof ContainsConditionInput
     */
    'type'?: ContainsConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContainsConditionInputTypeEnum {
    CONTAINS = 'contains'
}

/**
 * 
 * @export
 * @interface ContainsConditionOutput
 */
export interface ContainsConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof ContainsConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof ContainsConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof ContainsConditionOutput
     */
    'type'?: ContainsConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContainsConditionOutputTypeEnum {
    CONTAINS = 'contains'
}

/**
 * 
 * @export
 * @interface CreateDatasetFromHistoryInput
 */
export interface CreateDatasetFromHistoryInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDatasetFromHistoryInput
     */
    'name': string;
    /**
     * 
     * @type {HistoryFiltersInput}
     * @memberof CreateDatasetFromHistoryInput
     */
    'filters': HistoryFiltersInput;
    /**
     * 
     * @type {string}
     * @memberof CreateDatasetFromHistoryInput
     */
    'flow_id': string;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateDatasetFromHistoryInput
     */
    'input_columns_to_overwrite'?: Array<DatasetColumn>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDatasetFromHistoryInput
     */
    'mock_node_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDatasetFromHistoryInput
     */
    'output_column_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateDatasetFromHistoryInput
     */
    'outcome_columns'?: Array<DatasetColumn>;
    /**
     * 
     * @type {DatasetPurpose}
     * @memberof CreateDatasetFromHistoryInput
     */
    'purpose'?: DatasetPurpose;
    /**
     * 
     * @type {number}
     * @memberof CreateDatasetFromHistoryInput
     */
    'sub_sampling_size'?: number | null;
}


/**
 * 
 * @export
 * @interface CreateDatasetFromHistoryOutput
 */
export interface CreateDatasetFromHistoryOutput {
    /**
     * 
     * @type {string}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'name': string;
    /**
     * 
     * @type {HistoryFiltersOutput}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'filters': HistoryFiltersOutput;
    /**
     * 
     * @type {string}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'flow_id': string;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'input_columns_to_overwrite'?: Array<DatasetColumn>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'mock_node_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'output_column_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'outcome_columns'?: Array<DatasetColumn>;
    /**
     * 
     * @type {DatasetPurpose}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'purpose'?: DatasetPurpose;
    /**
     * 
     * @type {number}
     * @memberof CreateDatasetFromHistoryOutput
     */
    'sub_sampling_size'?: number | null;
}


/**
 * 
 * @export
 * @interface CreateFilePayload
 */
export interface CreateFilePayload {
    /**
     * 
     * @type {string}
     * @memberof CreateFilePayload
     */
    'file_name'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateJobSourceFromJobRunDatasetJob
 */
export interface CreateJobSourceFromJobRunDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'status': CreateJobSourceFromJobRunDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'type': CreateJobSourceFromJobRunDatasetJobTypeEnum;
    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobRequest}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'request': CreateJobSourceFromJobRunDatasetJobRequest;
    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobResponse}
     * @memberof CreateJobSourceFromJobRunDatasetJob
     */
    'response'?: CreateJobSourceFromJobRunDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateJobSourceFromJobRunDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateJobSourceFromJobRunDatasetJobTypeEnum {
    CREATE_JOB_SOURCE = 'create_job_source'
}

/**
 * 
 * @export
 * @interface CreateJobSourceFromJobRunDatasetJobCreation
 */
export interface CreateJobSourceFromJobRunDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJobCreation
     */
    'type': CreateJobSourceFromJobRunDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobRequest}
     * @memberof CreateJobSourceFromJobRunDatasetJobCreation
     */
    'request': CreateJobSourceFromJobRunDatasetJobRequest;
    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobResponse}
     * @memberof CreateJobSourceFromJobRunDatasetJobCreation
     */
    'response'?: CreateJobSourceFromJobRunDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateJobSourceFromJobRunDatasetJobCreationTypeEnum {
    CREATE_JOB_SOURCE = 'create_job_source'
}

/**
 * 
 * @export
 * @interface CreateJobSourceFromJobRunDatasetJobRequest
 */
export interface CreateJobSourceFromJobRunDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJobRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateJobSourceFromJobRunDatasetJobRequest
     */
    'status_codes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJobRequest
     */
    'job_run_id': string;
}
/**
 * 
 * @export
 * @interface CreateJobSourceFromJobRunDatasetJobResponse
 */
export interface CreateJobSourceFromJobRunDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateJobSourceFromJobRunDatasetJobResponse
     */
    'job_source_id': string;
}
/**
 * 
 * @export
 * @interface CreateSimulationDatasetInput
 */
export interface CreateSimulationDatasetInput {
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetInput
     */
    'name': string;
    /**
     * 
     * @type {HistoryFiltersInput}
     * @memberof CreateSimulationDatasetInput
     */
    'filters': HistoryFiltersInput;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetInput
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetInput
     */
    'flow_slug': string;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateSimulationDatasetInput
     */
    'input_columns_to_overwrite'?: Array<DatasetColumn>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSimulationDatasetInput
     */
    'mock_node_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSimulationDatasetInput
     */
    'output_column_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {DatasetPurpose}
     * @memberof CreateSimulationDatasetInput
     */
    'purpose'?: DatasetPurpose;
    /**
     * 
     * @type {number}
     * @memberof CreateSimulationDatasetInput
     */
    'sub_sampling_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetInput
     */
    'query_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSimulationDatasetInput
     */
    'estimated_total_row_count'?: number | null;
}


/**
 * 
 * @export
 * @interface CreateSimulationDatasetOutput
 */
export interface CreateSimulationDatasetOutput {
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetOutput
     */
    'name': string;
    /**
     * 
     * @type {HistoryFiltersOutput}
     * @memberof CreateSimulationDatasetOutput
     */
    'filters': HistoryFiltersOutput;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetOutput
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetOutput
     */
    'flow_slug': string;
    /**
     * 
     * @type {Array<DatasetColumn>}
     * @memberof CreateSimulationDatasetOutput
     */
    'input_columns_to_overwrite'?: Array<DatasetColumn>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSimulationDatasetOutput
     */
    'mock_node_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSimulationDatasetOutput
     */
    'output_column_names_to_include'?: Array<string> | null;
    /**
     * 
     * @type {DatasetPurpose}
     * @memberof CreateSimulationDatasetOutput
     */
    'purpose'?: DatasetPurpose;
    /**
     * 
     * @type {number}
     * @memberof CreateSimulationDatasetOutput
     */
    'sub_sampling_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimulationDatasetOutput
     */
    'query_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSimulationDatasetOutput
     */
    'estimated_total_row_count'?: number | null;
}


/**
 * 
 * @export
 * @interface DBResponse
 */
export interface DBResponse {
    /**
     * 
     * @type {DBResponseData}
     * @memberof DBResponse
     */
    'data': DBResponseData;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DBResponse
     */
    'insights': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DBResponse
     */
    'meta': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface DBResponseData
 */
export interface DBResponseData {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DBResponseData
     */
    'result': Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface DatasetColumn
 */
export interface DatasetColumn {
    /**
     * 
     * @type {string}
     * @memberof DatasetColumn
     */
    'desired_type': DatasetColumnDesiredTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DatasetColumn
     */
    'use_subflow_mocks'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatasetColumn
     */
    'name': string;
}

/**
    * @export
    * @enum {string}
    */
export enum DatasetColumnDesiredTypeEnum {
    STRING = 'string',
    BOOLEAN = 'boolean',
    NUMBER = 'number',
    INTEGER = 'integer',
    OBJECT = 'object',
    ARRAY = 'array',
    DATETIME = 'datetime',
    DATE = 'date',
    ANY = 'any',
    ENUM = 'enum'
}

/**
 * 
 * @export
 * @interface DatasetJobGenericError
 */
export interface DatasetJobGenericError {
    /**
     * 
     * @type {string}
     * @memberof DatasetJobGenericError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DatasetJobSourceConfiguration
 */
export interface DatasetJobSourceConfiguration {
    /**
     * 
     * @type {string}
     * @memberof DatasetJobSourceConfiguration
     */
    'type': DatasetJobSourceConfigurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatasetJobSourceConfiguration
     */
    'dataset_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum DatasetJobSourceConfigurationTypeEnum {
    DATASET = 'dataset'
}

/**
 * 
 * @export
 * @interface DatasetJobSourceConfigurationMetadataMappingEntry
 */
export interface DatasetJobSourceConfigurationMetadataMappingEntry {
    /**
     * 
     * @type {string}
     * @memberof DatasetJobSourceConfigurationMetadataMappingEntry
     */
    'db_field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatasetJobSourceConfigurationMetadataMappingEntry
     */
    'flow_input_field': DatasetJobSourceConfigurationMetadataMappingEntryFlowInputFieldEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DatasetJobSourceConfigurationMetadataMappingEntryFlowInputFieldEnum {
    ENTITY_ID = 'entity_id',
    VERSION = 'version'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DatasetPurpose {
    TEST_RUN = 'test_run',
    JOB_SOURCE = 'job_source',
    SIMULATION = 'simulation'
}


/**
 * Copy from flow_utils as aurora schemas package does not depend on flow_utils
 * @export
 * @enum {string}
 */

export enum DecisionEnvironment {
    LIVE = 'live',
    SANDBOX = 'sandbox',
    TEST = 'test'
}


/**
 * 
 * @export
 * @interface DownloadDatasetJob
 */
export interface DownloadDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof DownloadDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'status': DownloadDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof DownloadDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJob
     */
    'type': DownloadDatasetJobTypeEnum;
    /**
     * 
     * @type {DownloadDatasetJobRequest}
     * @memberof DownloadDatasetJob
     */
    'request': DownloadDatasetJobRequest;
    /**
     * 
     * @type {DownloadDatasetJobResponse}
     * @memberof DownloadDatasetJob
     */
    'response'?: DownloadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DownloadDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum DownloadDatasetJobTypeEnum {
    DOWNLOAD = 'download'
}

/**
 * 
 * @export
 * @interface DownloadDatasetJobCreation
 */
export interface DownloadDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobCreation
     */
    'type': DownloadDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {DownloadDatasetJobRequest}
     * @memberof DownloadDatasetJobCreation
     */
    'request': DownloadDatasetJobRequest;
    /**
     * 
     * @type {DownloadDatasetJobResponse}
     * @memberof DownloadDatasetJobCreation
     */
    'response'?: DownloadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DownloadDatasetJobCreationTypeEnum {
    DOWNLOAD = 'download'
}

/**
 * 
 * @export
 * @interface DownloadDatasetJobRequest
 */
export interface DownloadDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobRequest
     */
    'dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobRequest
     */
    'format': DownloadDatasetJobRequestFormatEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DownloadDatasetJobRequestFormatEnum {
    JSON = 'json',
    CSV = 'csv',
    XLSX = 'xlsx'
}

/**
 * 
 * @export
 * @interface DownloadDatasetJobResponse
 */
export interface DownloadDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobResponse
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobResponse
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDatasetJobResponse
     */
    's3_url'?: string | null;
}
/**
 * 
 * @export
 * @interface DuplicateDatasetJob
 */
export interface DuplicateDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'status': DuplicateDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof DuplicateDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJob
     */
    'type': DuplicateDatasetJobTypeEnum;
    /**
     * 
     * @type {DuplicateDatasetJobRequest}
     * @memberof DuplicateDatasetJob
     */
    'request': DuplicateDatasetJobRequest;
    /**
     * 
     * @type {DuplicateDatasetJobResponse}
     * @memberof DuplicateDatasetJob
     */
    'response'?: DuplicateDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DuplicateDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum DuplicateDatasetJobTypeEnum {
    DUPLICATE = 'duplicate'
}

/**
 * 
 * @export
 * @interface DuplicateDatasetJobCreation
 */
export interface DuplicateDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobCreation
     */
    'type': DuplicateDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {DuplicateDatasetJobRequest}
     * @memberof DuplicateDatasetJobCreation
     */
    'request': DuplicateDatasetJobRequest;
    /**
     * 
     * @type {DuplicateDatasetJobResponse}
     * @memberof DuplicateDatasetJobCreation
     */
    'response'?: DuplicateDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DuplicateDatasetJobCreationTypeEnum {
    DUPLICATE = 'duplicate'
}

/**
 * 
 * @export
 * @interface DuplicateDatasetJobRequest
 */
export interface DuplicateDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobRequest
     */
    'source_dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobRequest
     */
    'new_dataset_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDatasetJobRequest
     */
    'row_limit'?: number | null;
    /**
     * 
     * @type {DatasetPurpose}
     * @memberof DuplicateDatasetJobRequest
     */
    'purpose'?: DatasetPurpose;
}


/**
 * 
 * @export
 * @interface DuplicateDatasetJobResponse
 */
export interface DuplicateDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobResponse
     */
    'source_dataset_etag': string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDatasetJobResponse
     */
    'new_dataset_id': string;
}
/**
 * 
 * @export
 * @interface EntitiesPreviewResponse
 */
export interface EntitiesPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof EntitiesPreviewResponse
     */
    'execution_id': string;
}
/**
 * 
 * @export
 * @interface EntitiesSourcePreviewRequest
 */
export interface EntitiesSourcePreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof EntitiesSourcePreviewRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntitiesSourcePreviewRequest
     */
    'entity_schema': string;
    /**
     * 
     * @type {string}
     * @memberof EntitiesSourcePreviewRequest
     */
    'destination_field_name': string;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof EntitiesSourcePreviewRequest
     */
    'environment': DecisionEnvironment;
    /**
     * 
     * @type {EntitiesSourcePreviewRequestFilterCondition}
     * @memberof EntitiesSourcePreviewRequest
     */
    'filter_condition'?: EntitiesSourcePreviewRequestFilterCondition | null;
}


/**
 * @type EntitiesSourcePreviewRequestFilterCondition
 * @export
 */
export type EntitiesSourcePreviewRequestFilterCondition = { type: 'and' } & AndConditionInput | { type: 'contains' } & ContainsConditionInput | { type: 'eq' } & EqualsConditionInput | { type: 'gt' } & GreaterThanConditionInput | { type: 'gte' } & GreaterThanOrEqualsConditionInput | { type: 'is_in' } & IsInConditionInput | { type: 'is_null' } & IsNullConditionInput | { type: 'lt' } & LessThanConditionInput | { type: 'lte' } & LessThanOrEqualsConditionInput | { type: 'not' } & NotConditionInput | { type: 'or' } & OrConditionInput;

/**
 * 
 * @export
 * @interface EntityJobSourceConfigurationInput
 */
export interface EntityJobSourceConfigurationInput {
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationInput
     */
    'type': EntityJobSourceConfigurationInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationInput
     */
    'entity_schema': string;
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationInput
     */
    'destination_field_name': string;
    /**
     * 
     * @type {EntitiesSourcePreviewRequestFilterCondition}
     * @memberof EntityJobSourceConfigurationInput
     */
    'filter_condition'?: EntitiesSourcePreviewRequestFilterCondition | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityJobSourceConfigurationInputTypeEnum {
    ENTITY = 'entity'
}

/**
 * 
 * @export
 * @interface EntityJobSourceConfigurationOutput
 */
export interface EntityJobSourceConfigurationOutput {
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationOutput
     */
    'type': EntityJobSourceConfigurationOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationOutput
     */
    'entity_schema': string;
    /**
     * 
     * @type {string}
     * @memberof EntityJobSourceConfigurationOutput
     */
    'destination_field_name': string;
    /**
     * 
     * @type {EntityJobSourceConfigurationOutputFilterCondition}
     * @memberof EntityJobSourceConfigurationOutput
     */
    'filter_condition'?: EntityJobSourceConfigurationOutputFilterCondition | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityJobSourceConfigurationOutputTypeEnum {
    ENTITY = 'entity'
}

/**
 * @type EntityJobSourceConfigurationOutputFilterCondition
 * @export
 */
export type EntityJobSourceConfigurationOutputFilterCondition = { type: 'and' } & AndConditionOutput | { type: 'contains' } & ContainsConditionOutput | { type: 'eq' } & EqualsConditionOutput | { type: 'gt' } & GreaterThanConditionOutput | { type: 'gte' } & GreaterThanOrEqualsConditionOutput | { type: 'is_in' } & IsInConditionOutput | { type: 'is_null' } & IsNullConditionOutput | { type: 'lt' } & LessThanConditionOutput | { type: 'lte' } & LessThanOrEqualsConditionOutput | { type: 'not' } & NotConditionOutput | { type: 'or' } & OrConditionOutput;

/**
 * 
 * @export
 * @interface EntityPropertyRef
 */
export interface EntityPropertyRef {
    /**
     * 
     * @type {string}
     * @memberof EntityPropertyRef
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityPropertyRef
     */
    'type'?: EntityPropertyRefTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityPropertyRef
     */
    'property_name': string;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityPropertyRefTypeEnum {
    ENTITY_PROPERTY_REF = 'entity_property_ref'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJob
 */
export interface EntityUploadDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof EntityUploadDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'status': EntityUploadDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof EntityUploadDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityUploadDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'type': EntityUploadDatasetJobTypeEnum;
    /**
     * 
     * @type {EntityUploadDatasetJobRequest}
     * @memberof EntityUploadDatasetJob
     */
    'request': EntityUploadDatasetJobRequest;
    /**
     * 
     * @type {EntityUploadDatasetJobResponse}
     * @memberof EntityUploadDatasetJob
     */
    'response'?: EntityUploadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobTypeEnum {
    ENTITY_UPLOAD = 'entity_upload'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJobCreation
 */
export interface EntityUploadDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobCreation
     */
    'type': EntityUploadDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {EntityUploadDatasetJobRequest}
     * @memberof EntityUploadDatasetJobCreation
     */
    'request': EntityUploadDatasetJobRequest;
    /**
     * 
     * @type {EntityUploadDatasetJobResponse}
     * @memberof EntityUploadDatasetJobCreation
     */
    'response'?: EntityUploadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobCreationTypeEnum {
    ENTITY_UPLOAD = 'entity_upload'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJobRequest
 */
export interface EntityUploadDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'environment': EntityUploadDatasetJobRequestEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'entity_schema': EntityUploadDatasetJobRequestEntitySchemaEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'entity_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobRequestEnvironmentEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobRequestEntitySchemaEnum {
    ENTITY = 'Entity'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJobResponse
 */
export interface EntityUploadDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobResponse
     */
    's3_presigned_url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EntityUploadDatasetJobResponse
     */
    's3_presigned_fields': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface EqualsConditionInput
 */
export interface EqualsConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof EqualsConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof EqualsConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof EqualsConditionInput
     */
    'type'?: EqualsConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EqualsConditionInputTypeEnum {
    EQ = 'eq'
}

/**
 * 
 * @export
 * @interface EqualsConditionOutput
 */
export interface EqualsConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof EqualsConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof EqualsConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof EqualsConditionOutput
     */
    'type'?: EqualsConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EqualsConditionOutputTypeEnum {
    EQ = 'eq'
}

/**
 * API response version of EventUploadDatasetJob without auth_jwt in request.
 * @export
 * @interface EventUploadDatasetJobApiResponse
 */
export interface EventUploadDatasetJobApiResponse {
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'status': EventUploadDatasetJobApiResponseStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'type': EventUploadDatasetJobApiResponseTypeEnum;
    /**
     * 
     * @type {EventUploadDatasetJobRequestBase}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'request': EventUploadDatasetJobRequestBase;
    /**
     * 
     * @type {EventUploadDatasetJobResponse}
     * @memberof EventUploadDatasetJobApiResponse
     */
    'response'?: EventUploadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventUploadDatasetJobApiResponseStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum EventUploadDatasetJobApiResponseTypeEnum {
    EVENT_UPLOAD = 'event_upload'
}

/**
 * 
 * @export
 * @interface EventUploadDatasetJobCreation
 */
export interface EventUploadDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobCreation
     */
    'type': EventUploadDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {EventUploadDatasetJobRequest}
     * @memberof EventUploadDatasetJobCreation
     */
    'request': EventUploadDatasetJobRequest;
    /**
     * 
     * @type {EventUploadDatasetJobResponse}
     * @memberof EventUploadDatasetJobCreation
     */
    'response'?: EventUploadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventUploadDatasetJobCreationTypeEnum {
    EVENT_UPLOAD = 'event_upload'
}

/**
 * Full request with auth_jwt for internal use.
 * @export
 * @interface EventUploadDatasetJobRequest
 */
export interface EventUploadDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequest
     */
    'environment': EventUploadDatasetJobRequestEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequest
     */
    'event_type': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequest
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequest
     */
    'auth_jwt'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EventUploadDatasetJobRequestEnvironmentEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}

/**
 * Base request fields for EventUpload dataset job (excludes auth_jwt).
 * @export
 * @interface EventUploadDatasetJobRequestBase
 */
export interface EventUploadDatasetJobRequestBase {
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequestBase
     */
    'environment': EventUploadDatasetJobRequestBaseEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequestBase
     */
    'event_type': string;
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobRequestBase
     */
    'file_name': string;
}

/**
    * @export
    * @enum {string}
    */
export enum EventUploadDatasetJobRequestBaseEnvironmentEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}

/**
 * 
 * @export
 * @interface EventUploadDatasetJobResponse
 */
export interface EventUploadDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof EventUploadDatasetJobResponse
     */
    's3_presigned_url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EventUploadDatasetJobResponse
     */
    's3_presigned_fields': { [key: string]: string; };
}
/**
 * Copy from flow_utils
 * @export
 * @enum {string}
 */

export enum ExecutionMode {
    SYNC = 'sync',
    ASYNC = 'async'
}


/**
 * API response version of ExportDecisionsDatasetJob without auth_jwt in request.
 * @export
 * @interface ExportDecisionsDatasetJobApiResponse
 */
export interface ExportDecisionsDatasetJobApiResponse {
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'status': ExportDecisionsDatasetJobApiResponseStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'type': ExportDecisionsDatasetJobApiResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'flow_id': string;
    /**
     * 
     * @type {ExportDecisionsDatasetJobRequestBase}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'request': ExportDecisionsDatasetJobRequestBase;
    /**
     * 
     * @type {ExportDecisionsDatasetJobResponse}
     * @memberof ExportDecisionsDatasetJobApiResponse
     */
    'response'?: ExportDecisionsDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportDecisionsDatasetJobApiResponseStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum ExportDecisionsDatasetJobApiResponseTypeEnum {
    EXPORT_DECISIONS = 'export_decisions'
}

/**
 * 
 * @export
 * @interface ExportDecisionsDatasetJobCreation
 */
export interface ExportDecisionsDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobCreation
     */
    'type': ExportDecisionsDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {ExportDecisionsDatasetJobRequest}
     * @memberof ExportDecisionsDatasetJobCreation
     */
    'request': ExportDecisionsDatasetJobRequest;
    /**
     * 
     * @type {ExportDecisionsDatasetJobResponse}
     * @memberof ExportDecisionsDatasetJobCreation
     */
    'response'?: ExportDecisionsDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportDecisionsDatasetJobCreationTypeEnum {
    EXPORT_DECISIONS = 'export_decisions'
}

/**
 * Full request with auth_jwt for internal use.
 * @export
 * @interface ExportDecisionsDatasetJobRequest
 */
export interface ExportDecisionsDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'format': ExportDecisionsDatasetJobRequestFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'end_date': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'flow_versions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'status_codes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'sub_sampling_size'?: number | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequest
     */
    'auth_jwt'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportDecisionsDatasetJobRequestFormatEnum {
    JSON = 'json',
    CSV = 'csv'
}

/**
 * Base request fields for ExportDecisions dataset job (excludes auth_jwt).
 * @export
 * @interface ExportDecisionsDatasetJobRequestBase
 */
export interface ExportDecisionsDatasetJobRequestBase {
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'format': ExportDecisionsDatasetJobRequestBaseFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'end_date': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'flow_versions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'status_codes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'sub_sampling_size'?: number | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof ExportDecisionsDatasetJobRequestBase
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportDecisionsDatasetJobRequestBaseFormatEnum {
    JSON = 'json',
    CSV = 'csv'
}

/**
 * 
 * @export
 * @interface ExportDecisionsDatasetJobResponse
 */
export interface ExportDecisionsDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobResponse
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobResponse
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ExportDecisionsDatasetJobResponse
     */
    's3_url'?: string | null;
}
/**
 * 
 * @export
 * @interface FailedJobRunStatus
 */
export interface FailedJobRunStatus {
    /**
     * 
     * @type {string}
     * @memberof FailedJobRunStatus
     */
    'type': FailedJobRunStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FailedJobRunStatus
     */
    'error_title': string;
    /**
     * 
     * @type {string}
     * @memberof FailedJobRunStatus
     */
    'error_details': string;
}

/**
    * @export
    * @enum {string}
    */
export enum FailedJobRunStatusTypeEnum {
    FAILED = 'failed'
}

/**
 * 
 * @export
 * @interface FeatureRef
 */
export interface FeatureRef {
    /**
     * 
     * @type {string}
     * @memberof FeatureRef
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureRef
     */
    'type'?: FeatureRefTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeatureRef
     */
    'feature_key': string;
}

/**
    * @export
    * @enum {string}
    */
export enum FeatureRefTypeEnum {
    FEATURE_REF = 'feature_ref'
}

/**
 * 
 * @export
 * @interface FileDetails
 */
export interface FileDetails {
    /**
     * 
     * @type {string}
     * @memberof FileDetails
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FileDetails
     */
    'row_count': number;
    /**
     * 
     * @type {string}
     * @memberof FileDetails
     */
    'error'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileDetails
     */
    'bytes_size': number;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'operator': FilterOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof Filter
     */
    'value': any;
    /**
     * 
     * @type {Array<any>}
     * @memberof Filter
     */
    'values': Array<any>;
}

/**
    * @export
    * @enum {string}
    */
export enum FilterOperatorEnum {
    IN = 'in',
    NOT_IN = 'not_in'
}

/**
 * 
 * @export
 * @interface FlowInput
 */
export interface FlowInput {
    /**
     * 
     * @type {string}
     * @memberof FlowInput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowInput
     */
    'slug': string;
    /**
     * 
     * @type {Array<FlowVersion>}
     * @memberof FlowInput
     */
    'versions': Array<FlowVersion>;
}
/**
 * 
 * @export
 * @interface FlowOutput
 */
export interface FlowOutput {
    /**
     * 
     * @type {string}
     * @memberof FlowOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowOutput
     */
    'slug': string;
    /**
     * 
     * @type {Array<FlowVersion>}
     * @memberof FlowOutput
     */
    'versions': Array<FlowVersion>;
}
/**
 * 
 * @export
 * @interface FlowVersion
 */
export interface FlowVersion {
    /**
     * 
     * @type {string}
     * @memberof FlowVersion
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersion
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionInputSchema}
     * @memberof FlowVersion
     */
    'input_schema'?: FlowVersionInputSchema | null;
    /**
     * 
     * @type {string}
     * @memberof FlowVersion
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface FlowVersionInputSchema
 */
export interface FlowVersionInputSchema {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowVersionInputSchema
     */
    'properties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface GetDecisionsOutcomeFilter
 */
export interface GetDecisionsOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsOutcomeFilter
     */
    'outcome_type_key': string;
    /**
     * 
     * @type {Filter}
     * @memberof GetDecisionsOutcomeFilter
     */
    'filter': Filter;
}
/**
 * Base is used for both listing and creating exports. Does not include page_size, sort_by, start_end_time and end_end_time.
 * @export
 * @interface GetDecisionsParamsBaseInput
 */
export interface GetDecisionsParamsBaseInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'statuses'?: Array<GetDecisionsParamsBaseInputStatusesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'job_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'job_run_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_decision_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'environments'?: Array<GetDecisionsParamsBaseInputEnvironmentsEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'origin_types'?: Array<GetDecisionsParamsBaseInputOriginTypesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'related_entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'related_schemas'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'case_status'?: Array<GetDecisionsParamsBaseInputCaseStatusEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'case_assignees'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'start_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'end_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'starting_after'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseInputStatusesEnum {
    SUCCESSFUL = 'successful',
    PENDING = 'pending',
    FAILED = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseInputEnvironmentsEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseInputOriginTypesEnum {
    API_CALL = 'api_call',
    JOB = 'job',
    FLOW = 'flow'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseInputCaseStatusEnum {
    NEEDS_REVIEW = 'needs_review',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed'
}

/**
 * Base is used for both listing and creating exports. Does not include page_size, sort_by, start_end_time and end_end_time.
 * @export
 * @interface GetDecisionsParamsBaseOutput
 */
export interface GetDecisionsParamsBaseOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'statuses'?: Array<GetDecisionsParamsBaseOutputStatusesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'job_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'job_run_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_decision_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'environments'?: Array<GetDecisionsParamsBaseOutputEnvironmentsEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'origin_types'?: Array<GetDecisionsParamsBaseOutputOriginTypesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'related_entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'related_schemas'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'case_status'?: Array<GetDecisionsParamsBaseOutputCaseStatusEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'case_assignees'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'start_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'end_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'starting_after'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseOutputStatusesEnum {
    SUCCESSFUL = 'successful',
    PENDING = 'pending',
    FAILED = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseOutputEnvironmentsEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseOutputOriginTypesEnum {
    API_CALL = 'api_call',
    JOB = 'job',
    FLOW = 'flow'
}
/**
    * @export
    * @enum {string}
    */
export enum GetDecisionsParamsBaseOutputCaseStatusEnum {
    NEEDS_REVIEW = 'needs_review',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed'
}

/**
 * 
 * @export
 * @interface GetEntityCountResponse
 */
export interface GetEntityCountResponse {
    /**
     * 
     * @type {number}
     * @memberof GetEntityCountResponse
     */
    'count'?: number | null;
}
/**
 * 
 * @export
 * @interface GreaterThanConditionInput
 */
export interface GreaterThanConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanConditionInput
     */
    'type'?: GreaterThanConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanConditionInputTypeEnum {
    GT = 'gt'
}

/**
 * 
 * @export
 * @interface GreaterThanConditionOutput
 */
export interface GreaterThanConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanConditionOutput
     */
    'type'?: GreaterThanConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanConditionOutputTypeEnum {
    GT = 'gt'
}

/**
 * 
 * @export
 * @interface GreaterThanOrEqualsConditionInput
 */
export interface GreaterThanOrEqualsConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanOrEqualsConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanOrEqualsConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanOrEqualsConditionInput
     */
    'type'?: GreaterThanOrEqualsConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanOrEqualsConditionInputTypeEnum {
    GTE = 'gte'
}

/**
 * 
 * @export
 * @interface GreaterThanOrEqualsConditionOutput
 */
export interface GreaterThanOrEqualsConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof GreaterThanOrEqualsConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof GreaterThanOrEqualsConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof GreaterThanOrEqualsConditionOutput
     */
    'type'?: GreaterThanOrEqualsConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GreaterThanOrEqualsConditionOutputTypeEnum {
    GTE = 'gte'
}

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HistoricalDecisionExportCreate
 */
export interface HistoricalDecisionExportCreate {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportCreate
     */
    'format'?: HistoricalDecisionExportCreateFormatEnum | null;
    /**
     * 
     * @type {GetDecisionsParamsBaseOutput}
     * @memberof HistoricalDecisionExportCreate
     */
    'params': GetDecisionsParamsBaseOutput;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoricalDecisionExportCreateFormatEnum {
    JSON = 'json',
    NDJSON = 'ndjson'
}

/**
 * 
 * @export
 * @interface HistoryExportDatasetJob
 */
export interface HistoryExportDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof HistoryExportDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'status': HistoryExportDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof HistoryExportDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJob
     */
    'type': HistoryExportDatasetJobTypeEnum;
    /**
     * 
     * @type {HistoryExportDatasetJobRequestOutput}
     * @memberof HistoryExportDatasetJob
     */
    'request': HistoryExportDatasetJobRequestOutput;
    /**
     * 
     * @type {HistoryExportDatasetJobResponse}
     * @memberof HistoryExportDatasetJob
     */
    'response'?: HistoryExportDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum HistoryExportDatasetJobTypeEnum {
    HISTORY_EXPORT = 'history_export'
}

/**
 * 
 * @export
 * @interface HistoryExportDatasetJobCreation
 */
export interface HistoryExportDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobCreation
     */
    'type': HistoryExportDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {HistoryExportDatasetJobRequestInput}
     * @memberof HistoryExportDatasetJobCreation
     */
    'request': HistoryExportDatasetJobRequestInput;
    /**
     * 
     * @type {HistoryExportDatasetJobResponse}
     * @memberof HistoryExportDatasetJobCreation
     */
    'response'?: HistoryExportDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportDatasetJobCreationTypeEnum {
    HISTORY_EXPORT = 'history_export'
}

/**
 * 
 * @export
 * @interface HistoryExportDatasetJobRequestInput
 */
export interface HistoryExportDatasetJobRequestInput {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobRequestInput
     */
    'flow_slug': string;
    /**
     * 
     * @type {HistoryExportInputFiltersInput}
     * @memberof HistoryExportDatasetJobRequestInput
     */
    'input_filters': HistoryExportInputFiltersInput;
    /**
     * 
     * @type {HistoryExportOutputFilters}
     * @memberof HistoryExportDatasetJobRequestInput
     */
    'output_filters': HistoryExportOutputFilters;
    /**
     * 
     * @type {HistoryExportReferenceDataInput}
     * @memberof HistoryExportDatasetJobRequestInput
     */
    'reference_data'?: HistoryExportReferenceDataInput | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobRequestInput
     */
    'format': HistoryExportDatasetJobRequestInputFormatEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportDatasetJobRequestInputFormatEnum {
    JSON = 'json'
}

/**
 * 
 * @export
 * @interface HistoryExportDatasetJobRequestOutput
 */
export interface HistoryExportDatasetJobRequestOutput {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobRequestOutput
     */
    'flow_slug': string;
    /**
     * 
     * @type {HistoryExportInputFiltersOutput}
     * @memberof HistoryExportDatasetJobRequestOutput
     */
    'input_filters': HistoryExportInputFiltersOutput;
    /**
     * 
     * @type {HistoryExportOutputFilters}
     * @memberof HistoryExportDatasetJobRequestOutput
     */
    'output_filters': HistoryExportOutputFilters;
    /**
     * 
     * @type {HistoryExportReferenceDataOutput}
     * @memberof HistoryExportDatasetJobRequestOutput
     */
    'reference_data'?: HistoryExportReferenceDataOutput | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobRequestOutput
     */
    'format': HistoryExportDatasetJobRequestOutputFormatEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportDatasetJobRequestOutputFormatEnum {
    JSON = 'json'
}

/**
 * 
 * @export
 * @interface HistoryExportDatasetJobResponse
 */
export interface HistoryExportDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobResponse
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobResponse
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportDatasetJobResponse
     */
    's3_url'?: string | null;
}
/**
 * Filters for history export
 * @export
 * @interface HistoryExportInputFiltersInput
 */
export interface HistoryExportInputFiltersInput {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'entity_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryExportInputFiltersInput
     */
    'flow_versions'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportInputFiltersInput
     */
    'is_sandbox'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryExportInputFiltersInput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersInput
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof HistoryExportInputFiltersInput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}
/**
 * Filters for history export
 * @export
 * @interface HistoryExportInputFiltersOutput
 */
export interface HistoryExportInputFiltersOutput {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'entity_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryExportInputFiltersOutput
     */
    'flow_versions'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportInputFiltersOutput
     */
    'is_sandbox'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryExportInputFiltersOutput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportInputFiltersOutput
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof HistoryExportInputFiltersOutput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}
/**
 * 
 * @export
 * @interface HistoryExportOutputFilters
 */
export interface HistoryExportOutputFilters {
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportOutputFilters
     */
    'include_extra_fields'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportOutputFilters
     */
    'include_response_data'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportOutputFilters
     */
    'include_traffic_policy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportOutputFilters
     */
    'include_request_data'?: boolean;
}
/**
 * 
 * @export
 * @interface HistoryExportReferenceDataInput
 */
export interface HistoryExportReferenceDataInput {
    /**
     * 
     * @type {FlowInput}
     * @memberof HistoryExportReferenceDataInput
     */
    'flow'?: FlowInput | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HistoryExportReferenceDataInput
     */
    'traffic_policy_id_to_name_map'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HistoryExportReferenceDataInput
     */
    'version_id_to_name_map'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface HistoryExportReferenceDataOutput
 */
export interface HistoryExportReferenceDataOutput {
    /**
     * 
     * @type {FlowOutput}
     * @memberof HistoryExportReferenceDataOutput
     */
    'flow'?: FlowOutput | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HistoryExportReferenceDataOutput
     */
    'traffic_policy_id_to_name_map'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HistoryExportReferenceDataOutput
     */
    'version_id_to_name_map'?: { [key: string]: string; } | null;
}
/**
 * API response version of HistoryExportV3DatasetJob without auth_jwt in request.
 * @export
 * @interface HistoryExportV3DatasetJobApiResponse
 */
export interface HistoryExportV3DatasetJobApiResponse {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'status': HistoryExportV3DatasetJobApiResponseStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'type': HistoryExportV3DatasetJobApiResponseTypeEnum;
    /**
     * 
     * @type {HistoricalDecisionExportCreate}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'request': HistoricalDecisionExportCreate;
    /**
     * 
     * @type {HistoryExportV3DatasetJobResponse}
     * @memberof HistoryExportV3DatasetJobApiResponse
     */
    'response'?: HistoryExportV3DatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportV3DatasetJobApiResponseStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum HistoryExportV3DatasetJobApiResponseTypeEnum {
    HISTORY_EXPORT_V3 = 'history_export_v3'
}

/**
 * 
 * @export
 * @interface HistoryExportV3DatasetJobCreation
 */
export interface HistoryExportV3DatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobCreation
     */
    'type': HistoryExportV3DatasetJobCreationTypeEnum;
    /**
     * 
     * @type {HistoryExportV3DatasetJobRequest}
     * @memberof HistoryExportV3DatasetJobCreation
     */
    'request': HistoryExportV3DatasetJobRequest;
    /**
     * 
     * @type {HistoryExportV3DatasetJobResponse}
     * @memberof HistoryExportV3DatasetJobCreation
     */
    'response'?: HistoryExportV3DatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportV3DatasetJobCreationTypeEnum {
    HISTORY_EXPORT_V3 = 'history_export_v3'
}

/**
 * 
 * @export
 * @interface HistoryExportV3DatasetJobRequest
 */
export interface HistoryExportV3DatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobRequest
     */
    'format'?: HistoryExportV3DatasetJobRequestFormatEnum | null;
    /**
     * 
     * @type {GetDecisionsParamsBaseInput}
     * @memberof HistoryExportV3DatasetJobRequest
     */
    'params': GetDecisionsParamsBaseInput;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3DatasetJobRequest
     */
    'auth_jwt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportV3DatasetJobRequestFormatEnum {
    JSON = 'json',
    NDJSON = 'ndjson'
}

/**
 * Internal storage schema for historical decision export v3
 * @export
 * @interface HistoryExportV3DatasetJobResponse
 */
export interface HistoryExportV3DatasetJobResponse {
    /**
     * 
     * @type {HistoryExportV3ResultLocation}
     * @memberof HistoryExportV3DatasetJobResponse
     */
    'location'?: HistoryExportV3ResultLocation | null;
}
/**
 * 
 * @export
 * @interface HistoryExportV3ResultLocation
 */
export interface HistoryExportV3ResultLocation {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'type': HistoryExportV3ResultLocationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'expires_at': string;
}

/**
    * @export
    * @enum {string}
    */
export enum HistoryExportV3ResultLocationTypeEnum {
    S3 = 's3'
}

/**
 * 
 * @export
 * @interface HistoryFiltersInput
 */
export interface HistoryFiltersInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryFiltersInput
     */
    'flow_versions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryFiltersInput
     */
    'status_codes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersInput
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersInput
     */
    'end_date': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersInput
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersInput
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof HistoryFiltersInput
     */
    'environment'?: DecisionEnvironment | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof HistoryFiltersInput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}


/**
 * 
 * @export
 * @interface HistoryFiltersOutput
 */
export interface HistoryFiltersOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryFiltersOutput
     */
    'flow_versions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryFiltersOutput
     */
    'status_codes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersOutput
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersOutput
     */
    'end_date': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersOutput
     */
    'traffic_policy_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFiltersOutput
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof HistoryFiltersOutput
     */
    'environment'?: DecisionEnvironment | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof HistoryFiltersOutput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
}


/**
 * 
 * @export
 * @interface IsInConditionInput
 */
export interface IsInConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof IsInConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof IsInConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof IsInConditionInput
     */
    'type'?: IsInConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum IsInConditionInputTypeEnum {
    IS_IN = 'is_in'
}

/**
 * 
 * @export
 * @interface IsInConditionOutput
 */
export interface IsInConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof IsInConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof IsInConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof IsInConditionOutput
     */
    'type'?: IsInConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum IsInConditionOutputTypeEnum {
    IS_IN = 'is_in'
}

/**
 * 
 * @export
 * @interface IsNullConditionInput
 */
export interface IsNullConditionInput {
    /**
     * 
     * @type {string}
     * @memberof IsNullConditionInput
     */
    'type'?: IsNullConditionInputTypeEnum;
    /**
     * 
     * @type {Value}
     * @memberof IsNullConditionInput
     */
    'value': Value;
}

/**
    * @export
    * @enum {string}
    */
export enum IsNullConditionInputTypeEnum {
    IS_NULL = 'is_null'
}

/**
 * 
 * @export
 * @interface IsNullConditionOutput
 */
export interface IsNullConditionOutput {
    /**
     * 
     * @type {string}
     * @memberof IsNullConditionOutput
     */
    'type'?: IsNullConditionOutputTypeEnum;
    /**
     * 
     * @type {Value}
     * @memberof IsNullConditionOutput
     */
    'value': Value;
}

/**
    * @export
    * @enum {string}
    */
export enum IsNullConditionOutputTypeEnum {
    IS_NULL = 'is_null'
}

/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'description'?: string | null;
    /**
     * 
     * @type {JobStatus}
     * @memberof Job
     */
    'status': JobStatus;
    /**
     * 
     * @type {JobConfiguration}
     * @memberof Job
     */
    'configuration'?: JobConfiguration | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'flow_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'flow_version_id'?: string | null;
    /**
     * 
     * @type {JobTrafficPolicy}
     * @memberof Job
     */
    'active_traffic_policy'?: JobTrafficPolicy | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'schedule'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'schedule_timezone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'schedule_arn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'service_account_user_id'?: string | null;
    /**
     * 
     * @type {JobSource}
     * @memberof Job
     */
    'active_source'?: JobSource | null;
    /**
     * 
     * @type {JobDestination}
     * @memberof Job
     */
    'active_destination'?: JobDestination | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'last_run_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'live_runs_count': number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'sandbox_runs_count': number;
    /**
     * 
     * @type {JobTags}
     * @memberof Job
     */
    'tags'?: JobTags | null;
}


/**
 * Advanced configuration for a job.
 * @export
 * @interface JobConfiguration
 */
export interface JobConfiguration {
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'rate_limit'?: number | null;
    /**
     * 
     * @type {RateLimitInterval}
     * @memberof JobConfiguration
     */
    'rate_limit_interval'?: RateLimitInterval | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'execution_concurrency'?: number | null;
    /**
     * 
     * @type {ExecutionMode}
     * @memberof JobConfiguration
     */
    'execution_mode'?: ExecutionMode;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'decision_history_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'decision_history_failed_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'manual_review_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'external_call_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobConfiguration
     */
    'source_batch_size'?: number | null;
}


/**
 * 
 * @export
 * @interface JobCreate
 */
export interface JobCreate {
    /**
     * 
     * @type {string}
     * @memberof JobCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof JobCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobCreate
     */
    'flow_id': string;
    /**
     * 
     * @type {JobTags}
     * @memberof JobCreate
     */
    'tags'?: JobTags | null;
}
/**
 * 
 * @export
 * @interface JobDestination
 */
export interface JobDestination {
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof JobDestination
     */
    'name': string;
    /**
     * 
     * @type {Configuration}
     * @memberof JobDestination
     */
    'configuration': UnionConfiguration;
}
/**
 * 
 * @export
 * @interface JobDestinationCreateBase
 */
export interface JobDestinationCreateBase {
    /**
     * 
     * @type {string}
     * @memberof JobDestinationCreateBase
     */
    'name': string;
    /**
     * 
     * @type {Configuration}
     * @memberof JobDestinationCreateBase
     */
    'configuration': UnionConfiguration;
}
/**
 * 
 * @export
 * @interface JobDestinationPage
 */
export interface JobDestinationPage {
    /**
     * 
     * @type {Array<JobDestination>}
     * @memberof JobDestinationPage
     */
    'destinations': Array<JobDestination>;
    /**
     * 
     * @type {string}
     * @memberof JobDestinationPage
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface JobDestinationPatch
 */
export interface JobDestinationPatch {
    /**
     * 
     * @type {string}
     * @memberof JobDestinationPatch
     */
    'name'?: string | null;
    /**
     * 
     * @type {JobDestinationPatchConfiguration}
     * @memberof JobDestinationPatch
     */
    'configuration'?: JobDestinationPatchConfiguration | null;
}
/**
 * @type JobDestinationPatchConfiguration
 * @export
 */
export type JobDestinationPatchConfiguration = { type: 's3_bucket' } & S3BucketJobDestinationConfiguration | { type: 'sql' } & SQLJobDestinationConfiguration;

/**
 * 
 * @export
 * @interface JobDuplicate
 */
export interface JobDuplicate {
    /**
     * 
     * @type {string}
     * @memberof JobDuplicate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof JobDuplicate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface JobPage
 */
export interface JobPage {
    /**
     * 
     * @type {Array<Job>}
     * @memberof JobPage
     */
    'jobs': Array<Job>;
    /**
     * 
     * @type {string}
     * @memberof JobPage
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface JobPatch
 */
export interface JobPatch {
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'description'?: string | null;
    /**
     * 
     * @type {JobConfiguration}
     * @memberof JobPatch
     */
    'configuration'?: JobConfiguration | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'flow_version_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'schedule'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'schedule_timezone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'active_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobPatch
     */
    'active_destination'?: string | null;
    /**
     * 
     * @type {JobTags}
     * @memberof JobPatch
     */
    'tags'?: JobTags | null;
}
/**
 * 
 * @export
 * @interface JobRun
 */
export interface JobRun {
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'job_etag': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'flow_version_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'flow_version_name'?: string | null;
    /**
     * 
     * @type {JobTrafficPolicy}
     * @memberof JobRun
     */
    'traffic_policy'?: JobTrafficPolicy | null;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'source_name': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'source_etag': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'source_type': string;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'destination_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'destination_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'destination_etag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobRun
     */
    'destination_type'?: string | null;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof JobRun
     */
    'environment': DecisionEnvironment;
    /**
     * 
     * @type {Trigger}
     * @memberof JobRun
     */
    'trigger': Trigger;
    /**
     * 
     * @type {Status}
     * @memberof JobRun
     */
    'status': Status;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'total_rows_count': number;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'success_rows_count': number;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'failed_rows_count': number;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'pending_rows_count': number;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'ignored_rows_count': number;
    /**
     * 
     * @type {number}
     * @memberof JobRun
     */
    'history_rows_count': number;
    /**
     * 
     * @type {SimulationJobRunDetails}
     * @memberof JobRun
     */
    'simulation_job_run_details'?: SimulationJobRunDetails | null;
}


/**
 * 
 * @export
 * @interface JobRunCreateRequest
 */
export interface JobRunCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof JobRunCreateRequest
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof JobRunCreateRequest
     */
    'environment': DecisionEnvironment;
    /**
     * 
     * @type {string}
     * @memberof JobRunCreateRequest
     */
    'trigger_type'?: JobRunCreateRequestTriggerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JobRunCreateRequest
     */
    'source_id'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum JobRunCreateRequestTriggerTypeEnum {
    MANUAL = 'manual',
    SCHEDULE = 'schedule'
}

/**
 * 
 * @export
 * @interface JobRunOutputResponse
 */
export interface JobRunOutputResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof JobRunOutputResponse
     */
    's3_urls': Array<string>;
}
/**
 * 
 * @export
 * @interface JobRunPage
 */
export interface JobRunPage {
    /**
     * 
     * @type {Array<JobRun>}
     * @memberof JobRunPage
     */
    'runs': Array<JobRun>;
    /**
     * 
     * @type {string}
     * @memberof JobRunPage
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum JobRunStatusType {
    COMPLETED = 'completed',
    RUNNING = 'running',
    FAILED = 'failed',
    STOPPED = 'stopped',
    WRITING = 'writing',
    HISTORY_COMPLETE = 'history_complete'
}


/**
 * 
 * @export
 * @interface JobSource
 */
export interface JobSource {
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof JobSource
     */
    'name': string;
    /**
     * 
     * @type {Configuration1}
     * @memberof JobSource
     */
    'configuration': Configuration1;
}
/**
 * 
 * @export
 * @interface JobSourceCreate
 */
export interface JobSourceCreate {
    /**
     * 
     * @type {string}
     * @memberof JobSourceCreate
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof JobSourceCreate
     */
    'name': string;
    /**
     * 
     * @type {Configuration2}
     * @memberof JobSourceCreate
     */
    'configuration': Configuration2;
}
/**
 * 
 * @export
 * @interface JobSourcePage
 */
export interface JobSourcePage {
    /**
     * 
     * @type {Array<JobSource>}
     * @memberof JobSourcePage
     */
    'sources': Array<JobSource>;
    /**
     * 
     * @type {string}
     * @memberof JobSourcePage
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface JobSourcePatch
 */
export interface JobSourcePatch {
    /**
     * 
     * @type {string}
     * @memberof JobSourcePatch
     */
    'name'?: string | null;
    /**
     * 
     * @type {JobSourcePatchConfiguration}
     * @memberof JobSourcePatch
     */
    'configuration'?: JobSourcePatchConfiguration | null;
}
/**
 * @type JobSourcePatchConfiguration
 * @export
 */
export type JobSourcePatchConfiguration = { type: 'dataset' } & DatasetJobSourceConfiguration | { type: 'entity' } & EntityJobSourceConfigurationInput | { type: 's3_bucket_dataset' } & S3BucketDatasetSourceConfiguration | { type: 'sql' } & SQLJobSourceConfiguration;

/**
 * 
 * @export
 * @enum {string}
 */

export enum JobStatus {
    INACTIVE = 'inactive',
    ACTIVE = 'active'
}


/**
 * 
 * @export
 * @interface JobTags
 */
export interface JobTags {
    /**
     * 
     * @type {boolean}
     * @memberof JobTags
     */
    'simulation'?: boolean;
}
/**
 * 
 * @export
 * @interface JobTrafficPolicy
 */
export interface JobTrafficPolicy {
    /**
     * 
     * @type {string}
     * @memberof JobTrafficPolicy
     */
    'name': string;
    /**
     * 
     * @type {ProbabilisticPolicy}
     * @memberof JobTrafficPolicy
     */
    'policy': ProbabilisticPolicy;
    /**
     * 
     * @type {boolean}
     * @memberof JobTrafficPolicy
     */
    'stable_routing': boolean;
    /**
     * 
     * @type {string}
     * @memberof JobTrafficPolicy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JobTrafficPolicy
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof JobTrafficPolicy
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface JobTrafficPolicyCreate
 */
export interface JobTrafficPolicyCreate {
    /**
     * 
     * @type {string}
     * @memberof JobTrafficPolicyCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ProbabilisticPolicy}
     * @memberof JobTrafficPolicyCreate
     */
    'policy': ProbabilisticPolicy;
    /**
     * 
     * @type {boolean}
     * @memberof JobTrafficPolicyCreate
     */
    'stable_routing': boolean;
}
/**
 * 
 * @export
 * @interface LessThanConditionInput
 */
export interface LessThanConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanConditionInput
     */
    'type'?: LessThanConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanConditionInputTypeEnum {
    LT = 'lt'
}

/**
 * 
 * @export
 * @interface LessThanConditionOutput
 */
export interface LessThanConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanConditionOutput
     */
    'type'?: LessThanConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanConditionOutputTypeEnum {
    LT = 'lt'
}

/**
 * 
 * @export
 * @interface LessThanOrEqualsConditionInput
 */
export interface LessThanOrEqualsConditionInput {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanOrEqualsConditionInput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanOrEqualsConditionInput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanOrEqualsConditionInput
     */
    'type'?: LessThanOrEqualsConditionInputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanOrEqualsConditionInputTypeEnum {
    LTE = 'lte'
}

/**
 * 
 * @export
 * @interface LessThanOrEqualsConditionOutput
 */
export interface LessThanOrEqualsConditionOutput {
    /**
     * 
     * @type {Lhs}
     * @memberof LessThanOrEqualsConditionOutput
     */
    'lhs': Lhs;
    /**
     * 
     * @type {Rhs}
     * @memberof LessThanOrEqualsConditionOutput
     */
    'rhs': Rhs;
    /**
     * 
     * @type {string}
     * @memberof LessThanOrEqualsConditionOutput
     */
    'type'?: LessThanOrEqualsConditionOutputTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LessThanOrEqualsConditionOutputTypeEnum {
    LTE = 'lte'
}

/**
 * @type Lhs
 * @export
 */
export type Lhs = { type: 'entity_property_ref' } & EntityPropertyRef | { type: 'feature_ref' } & FeatureRef | { type: 'literal' } & Literal | { type: 'time_point_absolute' } & AbsoluteTimePoint | { type: 'time_point_relative' } & RelativeTimePoint;

/**
 * @type ListJobsDatasetJobsApiV1DatasetJobsGet200ResponseInner
 * @export
 */
export type ListJobsDatasetJobsApiV1DatasetJobsGet200ResponseInner = { type: 'assemble' } & AssembleDatasetJob | { type: 'assemble_simulation' } & AssembleSimulationDatasetJob | { type: 'create_job_source' } & CreateJobSourceFromJobRunDatasetJob | { type: 'download' } & DownloadDatasetJob | { type: 'duplicate' } & DuplicateDatasetJob | { type: 'entity_upload' } & EntityUploadDatasetJob | { type: 'event_upload' } & EventUploadDatasetJobApiResponse | { type: 'export_decisions' } & ExportDecisionsDatasetJobApiResponse | { type: 'history_export' } & HistoryExportDatasetJob | { type: 'history_export_v3' } & HistoryExportV3DatasetJobApiResponse | { type: 'simulation_download' } & SimulationDownloadDatasetJob | { type: 'simulation_failures' } & SimulationFailuresDatasetJob;

/**
 * 
 * @export
 * @interface Literal
 */
export interface Literal {
    /**
     * 
     * @type {string}
     * @memberof Literal
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Literal
     */
    'type'?: LiteralTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Literal
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum LiteralTypeEnum {
    LITERAL = 'literal'
}

/**
 * 
 * @export
 * @interface ManualJobRunTrigger
 */
export interface ManualJobRunTrigger {
    /**
     * 
     * @type {string}
     * @memberof ManualJobRunTrigger
     */
    'type': ManualJobRunTriggerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualJobRunTrigger
     */
    'triggered_by': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualJobRunTriggerTypeEnum {
    MANUAL = 'manual'
}

/**
 * 
 * @export
 * @interface MultiOutcomeFilter
 */
export interface MultiOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof MultiOutcomeFilter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof MultiOutcomeFilter
     */
    'operator': MultiOutcomeFilterOperatorEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof MultiOutcomeFilter
     */
    'values': Array<any>;
}

/**
    * @export
    * @enum {string}
    */
export enum MultiOutcomeFilterOperatorEnum {
    IN = 'in',
    NOT_IN = 'not_in'
}

/**
 * 
 * @export
 * @interface NotConditionInput
 */
export interface NotConditionInput {
    /**
     * 
     * @type {string}
     * @memberof NotConditionInput
     */
    'type'?: NotConditionInputTypeEnum;
    /**
     * 
     * @type {Condition}
     * @memberof NotConditionInput
     */
    'condition': Condition;
}

/**
    * @export
    * @enum {string}
    */
export enum NotConditionInputTypeEnum {
    NOT = 'not'
}

/**
 * 
 * @export
 * @interface NotConditionOutput
 */
export interface NotConditionOutput {
    /**
     * 
     * @type {string}
     * @memberof NotConditionOutput
     */
    'type'?: NotConditionOutputTypeEnum;
    /**
     * 
     * @type {Condition1}
     * @memberof NotConditionOutput
     */
    'condition': Condition1;
}

/**
    * @export
    * @enum {string}
    */
export enum NotConditionOutputTypeEnum {
    NOT = 'not'
}

/**
 * 
 * @export
 * @interface OrConditionInput
 */
export interface OrConditionInput {
    /**
     * 
     * @type {string}
     * @memberof OrConditionInput
     */
    'type'?: OrConditionInputTypeEnum;
    /**
     * 
     * @type {Array<AndConditionInputConditionsInner>}
     * @memberof OrConditionInput
     */
    'conditions'?: Array<AndConditionInputConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrConditionInputTypeEnum {
    OR = 'or'
}

/**
 * 
 * @export
 * @interface OrConditionOutput
 */
export interface OrConditionOutput {
    /**
     * 
     * @type {string}
     * @memberof OrConditionOutput
     */
    'type'?: OrConditionOutputTypeEnum;
    /**
     * 
     * @type {Array<AndConditionOutputConditionsInner>}
     * @memberof OrConditionOutput
     */
    'conditions'?: Array<AndConditionOutputConditionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum OrConditionOutputTypeEnum {
    OR = 'or'
}

/**
 * 
 * @export
 * @interface PreviewQueryRequest
 */
export interface PreviewQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewQueryRequest
     */
    'query': string;
    /**
     * 
     * @type {string}
     * @memberof PreviewQueryRequest
     */
    'connection_id': string;
    /**
     * 
     * @type {number}
     * @memberof PreviewQueryRequest
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface ProbabilisticPolicy
 */
export interface ProbabilisticPolicy {
    /**
     * 
     * @type {string}
     * @memberof ProbabilisticPolicy
     */
    'type': ProbabilisticPolicyTypeEnum;
    /**
     * 
     * @type {Array<ProbabilisticPolicyVersionEntry>}
     * @memberof ProbabilisticPolicy
     */
    'flow_versions': Array<ProbabilisticPolicyVersionEntry>;
}

/**
    * @export
    * @enum {string}
    */
export enum ProbabilisticPolicyTypeEnum {
    PROBABILISTIC = 'probabilistic'
}

/**
 * 
 * @export
 * @interface ProbabilisticPolicyVersionEntry
 */
export interface ProbabilisticPolicyVersionEntry {
    /**
     * 
     * @type {string}
     * @memberof ProbabilisticPolicyVersionEntry
     */
    'flow_version_id': string;
    /**
     * 
     * @type {number}
     * @memberof ProbabilisticPolicyVersionEntry
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RateLimitInterval {
    MILLISECOND = 'MILLISECOND',
    SECOND = 'SECOND',
    MINUTE = 'MINUTE',
    HOUR = 'HOUR'
}


/**
 * Represents a time point at a fixed offset from the current time. The offset can be negative for time points in the past.
 * @export
 * @interface RelativeTimePoint
 */
export interface RelativeTimePoint {
    /**
     * 
     * @type {string}
     * @memberof RelativeTimePoint
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelativeTimePoint
     */
    'type'?: RelativeTimePointTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RelativeTimePoint
     */
    'offset': number;
    /**
     * 
     * @type {TimeUnit}
     * @memberof RelativeTimePoint
     */
    'unit': TimeUnit;
}

/**
    * @export
    * @enum {string}
    */
export enum RelativeTimePointTypeEnum {
    TIME_POINT_RELATIVE = 'time_point_relative'
}

/**
 * @type ResponseCreateJobDatasetJobsApiV1DatasetJobsPost
 * @export
 */
export type ResponseCreateJobDatasetJobsApiV1DatasetJobsPost = { type: 'assemble' } & AssembleDatasetJob | { type: 'assemble_simulation' } & AssembleSimulationDatasetJob | { type: 'create_job_source' } & CreateJobSourceFromJobRunDatasetJob | { type: 'download' } & DownloadDatasetJob | { type: 'duplicate' } & DuplicateDatasetJob | { type: 'entity_upload' } & EntityUploadDatasetJob | { type: 'event_upload' } & EventUploadDatasetJobApiResponse | { type: 'export_decisions' } & ExportDecisionsDatasetJobApiResponse | { type: 'history_export' } & HistoryExportDatasetJob | { type: 'history_export_v3' } & HistoryExportV3DatasetJobApiResponse | { type: 'simulation_download' } & SimulationDownloadDatasetJob | { type: 'simulation_failures' } & SimulationFailuresDatasetJob;

/**
 * @type ResponseGetJobDatasetJobsApiV1DatasetJobsIdGet
 * @export
 */
export type ResponseGetJobDatasetJobsApiV1DatasetJobsIdGet = { type: 'assemble' } & AssembleDatasetJob | { type: 'assemble_simulation' } & AssembleSimulationDatasetJob | { type: 'create_job_source' } & CreateJobSourceFromJobRunDatasetJob | { type: 'download' } & DownloadDatasetJob | { type: 'duplicate' } & DuplicateDatasetJob | { type: 'entity_upload' } & EntityUploadDatasetJob | { type: 'event_upload' } & EventUploadDatasetJobApiResponse | { type: 'export_decisions' } & ExportDecisionsDatasetJobApiResponse | { type: 'history_export' } & HistoryExportDatasetJob | { type: 'history_export_v3' } & HistoryExportV3DatasetJobApiResponse | { type: 'simulation_download' } & SimulationDownloadDatasetJob | { type: 'simulation_failures' } & SimulationFailuresDatasetJob;

/**
 * @type ResponseHideJobDatasetJobsApiV1DatasetJobsIdHidePatch
 * @export
 */
export type ResponseHideJobDatasetJobsApiV1DatasetJobsIdHidePatch = { type: 'assemble' } & AssembleDatasetJob | { type: 'assemble_simulation' } & AssembleSimulationDatasetJob | { type: 'create_job_source' } & CreateJobSourceFromJobRunDatasetJob | { type: 'download' } & DownloadDatasetJob | { type: 'duplicate' } & DuplicateDatasetJob | { type: 'entity_upload' } & EntityUploadDatasetJob | { type: 'event_upload' } & EventUploadDatasetJobApiResponse | { type: 'export_decisions' } & ExportDecisionsDatasetJobApiResponse | { type: 'history_export' } & HistoryExportDatasetJob | { type: 'history_export_v3' } & HistoryExportV3DatasetJobApiResponse | { type: 'simulation_download' } & SimulationDownloadDatasetJob | { type: 'simulation_failures' } & SimulationFailuresDatasetJob;

/**
 * @type Rhs
 * @export
 */
export type Rhs = { type: 'entity_property_ref' } & EntityPropertyRef | { type: 'feature_ref' } & FeatureRef | { type: 'literal' } & Literal | { type: 'time_point_absolute' } & AbsoluteTimePoint | { type: 'time_point_relative' } & RelativeTimePoint;

/**
 * 
 * @export
 * @interface RunningJobRunStatus
 */
export interface RunningJobRunStatus {
    /**
     * 
     * @type {string}
     * @memberof RunningJobRunStatus
     */
    'type': RunningJobRunStatusTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum RunningJobRunStatusTypeEnum {
    RUNNING = 'running'
}

/**
 * 
 * @export
 * @interface S3BucketDataset
 */
export interface S3BucketDataset {
    /**
     * 
     * @type {string}
     * @memberof S3BucketDataset
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDataset
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDataset
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDataset
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDataset
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface S3BucketDatasetDetail
 */
export interface S3BucketDatasetDetail {
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetDetail
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetDetail
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetDetail
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof S3BucketDatasetDetail
     */
    'file_count': number;
    /**
     * 
     * @type {number}
     * @memberof S3BucketDatasetDetail
     */
    'total_row_count': number;
    /**
     * 
     * @type {Array<FileDetails>}
     * @memberof S3BucketDatasetDetail
     */
    'files': Array<FileDetails>;
    /**
     * 
     * @type {number}
     * @memberof S3BucketDatasetDetail
     */
    'bytes_size': number;
}
/**
 * 
 * @export
 * @interface S3BucketDatasetPost
 */
export interface S3BucketDatasetPost {
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetPost
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetPost
     */
    'flow_id': string;
}
/**
 * 
 * @export
 * @interface S3BucketDatasetSourceConfiguration
 */
export interface S3BucketDatasetSourceConfiguration {
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetSourceConfiguration
     */
    'type': S3BucketDatasetSourceConfigurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof S3BucketDatasetSourceConfiguration
     */
    's3_bucket_dataset_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum S3BucketDatasetSourceConfigurationTypeEnum {
    S3_BUCKET_DATASET = 's3_bucket_dataset'
}

/**
 * 
 * @export
 * @interface S3BucketJobDestinationConfiguration
 */
export interface S3BucketJobDestinationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof S3BucketJobDestinationConfiguration
     */
    'type': S3BucketJobDestinationConfigurationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof S3BucketJobDestinationConfiguration
     */
    'output_files_number'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum S3BucketJobDestinationConfigurationTypeEnum {
    S3_BUCKET = 's3_bucket'
}

/**
 * 
 * @export
 * @interface S3BucketListResponse
 */
export interface S3BucketListResponse {
    /**
     * 
     * @type {Array<S3BucketDataset>}
     * @memberof S3BucketListResponse
     */
    'datasets': Array<S3BucketDataset>;
    /**
     * 
     * @type {string}
     * @memberof S3BucketListResponse
     */
    'next_page_token'?: string | null;
}
/**
 * Represents a response containing a pre-signed URL and form fields for S3 uploads.  Attributes:     url (str): The pre-signed URL for the S3 upload.     fields (dict[str, str]): A dictionary of prefilled form fields to build on top of.     Elements that may be included are acl, Cache-Control, Content-Type,     Content-Disposition, Content-Encoding, Expires, success_action_redirect,     redirect, success_action_status, and x-amz-meta-.
 * @export
 * @interface S3PresignedPostResponse
 */
export interface S3PresignedPostResponse {
    /**
     * 
     * @type {string}
     * @memberof S3PresignedPostResponse
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof S3PresignedPostResponse
     */
    'fields': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface SQLJobDestinationConfiguration
 */
export interface SQLJobDestinationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfiguration
     */
    'type': SQLJobDestinationConfigurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfiguration
     */
    'connection_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfiguration
     */
    'table_prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfiguration
     */
    'credentials_for_sandbox_run'?: SQLJobDestinationConfigurationCredentialsForSandboxRunEnum | null;
    /**
     * 
     * @type {Array<SQLJobDestinationConfigurationMappingEntry>}
     * @memberof SQLJobDestinationConfiguration
     */
    'mapping': Array<SQLJobDestinationConfigurationMappingEntry>;
}

/**
    * @export
    * @enum {string}
    */
export enum SQLJobDestinationConfigurationTypeEnum {
    SQL = 'sql'
}
/**
    * @export
    * @enum {string}
    */
export enum SQLJobDestinationConfigurationCredentialsForSandboxRunEnum {
    SANDBOX_CREDENTIALS = 'sandbox_credentials',
    LIVE_CREDENTIALS = 'live_credentials'
}

/**
 * Mapping from a field in output schema to db column name # TODO: ITER-3124 will unblock having
 * @export
 * @interface SQLJobDestinationConfigurationMappingEntry
 */
export interface SQLJobDestinationConfigurationMappingEntry {
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfigurationMappingEntry
     */
    'db_field': string;
    /**
     * 
     * @type {string}
     * @memberof SQLJobDestinationConfigurationMappingEntry
     */
    'flow_output_field': string;
}
/**
 * 
 * @export
 * @interface SQLJobSourceConfiguration
 */
export interface SQLJobSourceConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfiguration
     */
    'type': SQLJobSourceConfigurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfiguration
     */
    'connection_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfiguration
     */
    'query'?: string | null;
    /**
     * 
     * @type {Array<SQLJobSourceConfigurationMappingEntry>}
     * @memberof SQLJobSourceConfiguration
     */
    'mapping': Array<SQLJobSourceConfigurationMappingEntry>;
    /**
     * 
     * @type {Array<DatasetJobSourceConfigurationMetadataMappingEntry>}
     * @memberof SQLJobSourceConfiguration
     */
    'metadata_mapping'?: Array<DatasetJobSourceConfigurationMetadataMappingEntry> | null;
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfiguration
     */
    'credentials_for_sandbox_run'?: SQLJobSourceConfigurationCredentialsForSandboxRunEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfiguration
     */
    'order_key'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SQLJobSourceConfigurationTypeEnum {
    SQL = 'sql'
}
/**
    * @export
    * @enum {string}
    */
export enum SQLJobSourceConfigurationCredentialsForSandboxRunEnum {
    SANDBOX_CREDENTIALS = 'sandbox_credentials',
    LIVE_CREDENTIALS = 'live_credentials'
}

/**
 * 
 * @export
 * @interface SQLJobSourceConfigurationMappingEntry
 */
export interface SQLJobSourceConfigurationMappingEntry {
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfigurationMappingEntry
     */
    'db_field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SQLJobSourceConfigurationMappingEntry
     */
    'flow_input_field': string;
}
/**
 * 
 * @export
 * @interface ScheduleJobRunTrigger
 */
export interface ScheduleJobRunTrigger {
    /**
     * 
     * @type {string}
     * @memberof ScheduleJobRunTrigger
     */
    'type': ScheduleJobRunTriggerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleJobRunTrigger
     */
    'schedule': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleJobRunTrigger
     */
    'service_account_user_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ScheduleJobRunTriggerTypeEnum {
    SCHEDULE = 'schedule'
}

/**
 * 
 * @export
 * @interface SimulationDownloadDatasetJob
 */
export interface SimulationDownloadDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof SimulationDownloadDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'status': SimulationDownloadDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof SimulationDownloadDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationDownloadDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJob
     */
    'type': SimulationDownloadDatasetJobTypeEnum;
    /**
     * 
     * @type {SimulationDownloadDatasetJobRequest}
     * @memberof SimulationDownloadDatasetJob
     */
    'request': SimulationDownloadDatasetJobRequest;
    /**
     * 
     * @type {SimulationDownloadDatasetJobResponse}
     * @memberof SimulationDownloadDatasetJob
     */
    'response'?: SimulationDownloadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationDownloadDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationDownloadDatasetJobTypeEnum {
    SIMULATION_DOWNLOAD = 'simulation_download'
}

/**
 * 
 * @export
 * @interface SimulationDownloadDatasetJobCreation
 */
export interface SimulationDownloadDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobCreation
     */
    'type': SimulationDownloadDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {SimulationDownloadDatasetJobRequest}
     * @memberof SimulationDownloadDatasetJobCreation
     */
    'request': SimulationDownloadDatasetJobRequest;
    /**
     * 
     * @type {SimulationDownloadDatasetJobResponse}
     * @memberof SimulationDownloadDatasetJobCreation
     */
    'response'?: SimulationDownloadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationDownloadDatasetJobCreationTypeEnum {
    SIMULATION_DOWNLOAD = 'simulation_download'
}

/**
 * 
 * @export
 * @interface SimulationDownloadDatasetJobRequest
 */
export interface SimulationDownloadDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobRequest
     */
    'simulation_job_run_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobRequest
     */
    'format': SimulationDownloadDatasetJobRequestFormatEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationDownloadDatasetJobRequestFormatEnum {
    CSV = 'csv',
    NDJSON = 'ndjson'
}

/**
 * 
 * @export
 * @interface SimulationDownloadDatasetJobResponse
 */
export interface SimulationDownloadDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobResponse
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobResponse
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDownloadDatasetJobResponse
     */
    's3_url'?: string | null;
}
/**
 * 
 * @export
 * @interface SimulationFailuresDatasetJob
 */
export interface SimulationFailuresDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof SimulationFailuresDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'status': SimulationFailuresDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof SimulationFailuresDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationFailuresDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJob
     */
    'type': SimulationFailuresDatasetJobTypeEnum;
    /**
     * 
     * @type {SimulationFailuresDatasetJobRequest}
     * @memberof SimulationFailuresDatasetJob
     */
    'request': SimulationFailuresDatasetJobRequest;
    /**
     * 
     * @type {SimulationFailuresDatasetJobResponse}
     * @memberof SimulationFailuresDatasetJob
     */
    'response'?: SimulationFailuresDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationFailuresDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationFailuresDatasetJobTypeEnum {
    SIMULATION_FAILURES = 'simulation_failures'
}

/**
 * 
 * @export
 * @interface SimulationFailuresDatasetJobCreation
 */
export interface SimulationFailuresDatasetJobCreation {
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJobCreation
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJobCreation
     */
    'type': SimulationFailuresDatasetJobCreationTypeEnum;
    /**
     * 
     * @type {SimulationFailuresDatasetJobRequest}
     * @memberof SimulationFailuresDatasetJobCreation
     */
    'request': SimulationFailuresDatasetJobRequest;
    /**
     * 
     * @type {SimulationFailuresDatasetJobResponse}
     * @memberof SimulationFailuresDatasetJobCreation
     */
    'response'?: SimulationFailuresDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationFailuresDatasetJobCreationTypeEnum {
    SIMULATION_FAILURES = 'simulation_failures'
}

/**
 * 
 * @export
 * @interface SimulationFailuresDatasetJobRequest
 */
export interface SimulationFailuresDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJobRequest
     */
    'simulation_job_run_id': string;
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJobRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SimulationFailuresDatasetJobResponse
 */
export interface SimulationFailuresDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof SimulationFailuresDatasetJobResponse
     */
    'dataset_id': string;
}
/**
 * 
 * @export
 * @interface SimulationJobRunDetails
 */
export interface SimulationJobRunDetails {
    /**
     * 
     * @type {string}
     * @memberof SimulationJobRunDetails
     */
    'id': string;
    /**
     * 
     * @type {SimulationPostprocessingStatus}
     * @memberof SimulationJobRunDetails
     */
    'post_processing_status': SimulationPostprocessingStatus | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum SimulationPostprocessingStatus {
    SCHEDULED = 'scheduled',
    COMPLETED = 'completed',
    FAILED = 'failed'
}


/**
 * 
 * @export
 * @interface SingleOutcomeFilter
 */
export interface SingleOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof SingleOutcomeFilter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof SingleOutcomeFilter
     */
    'operator': SingleOutcomeFilterOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof SingleOutcomeFilter
     */
    'value': any;
}

/**
    * @export
    * @enum {string}
    */
export enum SingleOutcomeFilterOperatorEnum {
    DOUBLE_EQUAL = '==',
    NOT_EQUAL = '!=',
    GREATER_THAN = '>',
    GREATER_THAN_OR_EQUAL_TO = '>=',
    LESS_THAN = '<',
    LESS_THAN_OR_EQUAL_TO = '<='
}

/**
 * 
 * @export
 * @interface SourcePreviewData
 */
export interface SourcePreviewData {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof SourcePreviewData
     */
    'results': Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface StartEntityCountRequest
 */
export interface StartEntityCountRequest {
    /**
     * 
     * @type {string}
     * @memberof StartEntityCountRequest
     */
    'entity_schema': string;
    /**
     * 
     * @type {EntitiesSourcePreviewRequestFilterCondition}
     * @memberof StartEntityCountRequest
     */
    'filter_condition'?: EntitiesSourcePreviewRequestFilterCondition | null;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof StartEntityCountRequest
     */
    'environment': DecisionEnvironment;
}


/**
 * 
 * @export
 * @interface StartEntityCountResponse
 */
export interface StartEntityCountResponse {
    /**
     * 
     * @type {string}
     * @memberof StartEntityCountResponse
     */
    'execution_id': string;
}
/**
 * @type Status
 * @export
 */
export type Status = { type: 'completed' } & CompletedJobRunStatus | { type: 'failed' } & FailedJobRunStatus | { type: 'running' } & RunningJobRunStatus | { type: 'stopped' } & StoppedJobRunStatus | { type: 'writing' } & WritingJobRunStatus;

/**
 * 
 * @export
 * @interface StoppedJobRunStatus
 */
export interface StoppedJobRunStatus {
    /**
     * 
     * @type {string}
     * @memberof StoppedJobRunStatus
     */
    'type': StoppedJobRunStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoppedJobRunStatus
     */
    'stopped_by': string;
}

/**
    * @export
    * @enum {string}
    */
export enum StoppedJobRunStatusTypeEnum {
    STOPPED = 'stopped'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum TimeUnit {
    SECONDS = 'seconds',
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks'
}


/**
 * @type Trigger
 * @export
 */
export type Trigger = { type: 'manual' } & ManualJobRunTrigger | { type: 'schedule' } & ScheduleJobRunTrigger;

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * @type Value
 * @export
 */
export type Value = { type: 'entity_property_ref' } & EntityPropertyRef | { type: 'feature_ref' } & FeatureRef | { type: 'literal' } & Literal | { type: 'time_point_absolute' } & AbsoluteTimePoint | { type: 'time_point_relative' } & RelativeTimePoint;

/**
 * 
 * @export
 * @interface WritingJobRunStatus
 */
export interface WritingJobRunStatus {
    /**
     * 
     * @type {string}
     * @memberof WritingJobRunStatus
     */
    'type': WritingJobRunStatusTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WritingJobRunStatusTypeEnum {
    WRITING = 'writing'
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a file to a dataset
         * @param {string} s3BucketDatasetId 
         * @param {CreateFilePayload} createFilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost: async (s3BucketDatasetId: string, createFilePayload: CreateFilePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 's3BucketDatasetId' is not null or undefined
            assertParamExists('createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost', 's3BucketDatasetId', s3BucketDatasetId)
            // verify required parameter 'createFilePayload' is not null or undefined
            assertParamExists('createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost', 'createFilePayload', createFilePayload)
            const localVarPath = `/s3_bucket_datasets/api/v1/s3_bucket_datasets/{s3_bucket_dataset_id}/file`
                .replace(`{${"s3_bucket_dataset_id"}}`, encodeURIComponent(String(s3BucketDatasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFilePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a batch dataset
         * @param {S3BucketDatasetPost} s3BucketDatasetPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost: async (s3BucketDatasetPost: S3BucketDatasetPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 's3BucketDatasetPost' is not null or undefined
            assertParamExists('createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost', 's3BucketDatasetPost', s3BucketDatasetPost)
            const localVarPath = `/s3_bucket_datasets/api/v1/s3_bucket_datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(s3BucketDatasetPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a job
         * @param {Body} body 
         * @param {boolean} [iceberg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobDatasetJobsApiV1DatasetJobsPost: async (body: Body, iceberg?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createJobDatasetJobsApiV1DatasetJobsPost', 'body', body)
            const localVarPath = `/dataset_jobs/api/v1/dataset_jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an s3 bucket dataset
         * @param {string} s3BucketDatasetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete: async (s3BucketDatasetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 's3BucketDatasetId' is not null or undefined
            assertParamExists('deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete', 's3BucketDatasetId', s3BucketDatasetId)
            const localVarPath = `/s3_bucket_datasets/api/v1/s3_bucket_datasets/{s3_bucket_dataset_id}`
                .replace(`{${"s3_bucket_dataset_id"}}`, encodeURIComponent(String(s3BucketDatasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get job by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobDatasetJobsApiV1DatasetJobsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobDatasetJobsApiV1DatasetJobsIdGet', 'id', id)
            const localVarPath = `/dataset_jobs/api/v1/dataset_jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information about a dataset
         * @param {string} s3BucketDatasetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet: async (s3BucketDatasetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 's3BucketDatasetId' is not null or undefined
            assertParamExists('getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet', 's3BucketDatasetId', s3BucketDatasetId)
            const localVarPath = `/s3_bucket_datasets/api/v1/s3_bucket_datasets/{s3_bucket_dataset_id}`
                .replace(`{${"s3_bucket_dataset_id"}}`, encodeURIComponent(String(s3BucketDatasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideJobDatasetJobsApiV1DatasetJobsIdHidePatch: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hideJobDatasetJobsApiV1DatasetJobsIdHidePatch', 'id', id)
            const localVarPath = `/dataset_jobs/api/v1/dataset_jobs/{id}/hide`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get jobs for filters
         * @param {string} flowId 
         * @param {number} limit 
         * @param {number} offset 
         * @param {string} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobsDatasetJobsApiV1DatasetJobsGet: async (flowId: string, limit: number, offset: number, statuses: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('listJobsDatasetJobsApiV1DatasetJobsGet', 'flowId', flowId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listJobsDatasetJobsApiV1DatasetJobsGet', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listJobsDatasetJobsApiV1DatasetJobsGet', 'offset', offset)
            // verify required parameter 'statuses' is not null or undefined
            assertParamExists('listJobsDatasetJobsApiV1DatasetJobsGet', 'statuses', statuses)
            const localVarPath = `/dataset_jobs/api/v1/dataset_jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all datasets for a flow
         * @param {string | null} [flowId] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet: async (flowId?: string | null, pageSize?: number | null, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/s3_bucket_datasets/api/v1/s3_bucket_datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a file to a dataset
         * @param {string} s3BucketDatasetId 
         * @param {CreateFilePayload} createFilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(s3BucketDatasetId: string, createFilePayload: CreateFilePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3PresignedPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(s3BucketDatasetId, createFilePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a batch dataset
         * @param {S3BucketDatasetPost} s3BucketDatasetPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(s3BucketDatasetPost: S3BucketDatasetPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3BucketDataset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(s3BucketDatasetPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a job
         * @param {Body} body 
         * @param {boolean} [iceberg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobDatasetJobsApiV1DatasetJobsPost(body: Body, iceberg?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCreateJobDatasetJobsApiV1DatasetJobsPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobDatasetJobsApiV1DatasetJobsPost(body, iceberg, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createJobDatasetJobsApiV1DatasetJobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an s3 bucket dataset
         * @param {string} s3BucketDatasetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(s3BucketDatasetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(s3BucketDatasetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get job by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobDatasetJobsApiV1DatasetJobsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetJobDatasetJobsApiV1DatasetJobsIdGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobDatasetJobsApiV1DatasetJobsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getJobDatasetJobsApiV1DatasetJobsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get information about a dataset
         * @param {string} s3BucketDatasetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(s3BucketDatasetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3BucketDatasetDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(s3BucketDatasetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHideJobDatasetJobsApiV1DatasetJobsIdHidePatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.hideJobDatasetJobsApiV1DatasetJobsIdHidePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get jobs for filters
         * @param {string} flowId 
         * @param {number} limit 
         * @param {number} offset 
         * @param {string} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobsDatasetJobsApiV1DatasetJobsGet(flowId: string, limit: number, offset: number, statuses: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListJobsDatasetJobsApiV1DatasetJobsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobsDatasetJobsApiV1DatasetJobsGet(flowId, limit, offset, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listJobsDatasetJobsApiV1DatasetJobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all datasets for a flow
         * @param {string | null} [flowId] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(flowId?: string | null, pageSize?: number | null, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3BucketListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(flowId, pageSize, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a file to a dataset
         * @param {DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(requestParameters: DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<S3PresignedPostResponse> {
            return localVarFp.createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(requestParameters.s3BucketDatasetId, requestParameters.createFilePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a batch dataset
         * @param {DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(requestParameters: DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<S3BucketDataset> {
            return localVarFp.createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(requestParameters.s3BucketDatasetPost, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a job
         * @param {DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobDatasetJobsApiV1DatasetJobsPost(requestParameters: DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreateJobDatasetJobsApiV1DatasetJobsPost> {
            return localVarFp.createJobDatasetJobsApiV1DatasetJobsPost(requestParameters.body, requestParameters.iceberg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an s3 bucket dataset
         * @param {DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(requestParameters: DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(requestParameters.s3BucketDatasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get job by id
         * @param {DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobDatasetJobsApiV1DatasetJobsIdGet(requestParameters: DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetJobDatasetJobsApiV1DatasetJobsIdGet> {
            return localVarFp.getJobDatasetJobsApiV1DatasetJobsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information about a dataset
         * @param {DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(requestParameters: DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<S3BucketDatasetDetail> {
            return localVarFp.getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(requestParameters.s3BucketDatasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide a job
         * @param {DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(requestParameters: DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseHideJobDatasetJobsApiV1DatasetJobsIdHidePatch> {
            return localVarFp.hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get jobs for filters
         * @param {DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobsDatasetJobsApiV1DatasetJobsGet(requestParameters: DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ListJobsDatasetJobsApiV1DatasetJobsGet200ResponseInner>> {
            return localVarFp.listJobsDatasetJobsApiV1DatasetJobsGet(requestParameters.flowId, requestParameters.limit, requestParameters.offset, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all datasets for a flow
         * @param {DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(requestParameters: DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<S3BucketListResponse> {
            return localVarFp.listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(requestParameters.flowId, requestParameters.pageSize, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest
 */
export interface DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost
     */
    readonly s3BucketDatasetId: string

    /**
     * 
     * @type {CreateFilePayload}
     * @memberof DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost
     */
    readonly createFilePayload: CreateFilePayload
}

/**
 * Request parameters for createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest
 */
export interface DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest {
    /**
     * 
     * @type {S3BucketDatasetPost}
     * @memberof DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost
     */
    readonly s3BucketDatasetPost: S3BucketDatasetPost
}

/**
 * Request parameters for createJobDatasetJobsApiV1DatasetJobsPost operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest
 */
export interface DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest {
    /**
     * 
     * @type {Body}
     * @memberof DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPost
     */
    readonly body: Body

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPost
     */
    readonly iceberg?: boolean
}

/**
 * Request parameters for deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest
 */
export interface DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete
     */
    readonly s3BucketDatasetId: string
}

/**
 * Request parameters for getJobDatasetJobsApiV1DatasetJobsIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest
 */
export interface DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest
 */
export interface DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet
     */
    readonly s3BucketDatasetId: string
}

/**
 * Request parameters for hideJobDatasetJobsApiV1DatasetJobsIdHidePatch operation in DefaultApi.
 * @export
 * @interface DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest
 */
export interface DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatch
     */
    readonly id: string
}

/**
 * Request parameters for listJobsDatasetJobsApiV1DatasetJobsGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest
 */
export interface DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListJobsDatasetJobsApiV1DatasetJobsGet
     */
    readonly flowId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListJobsDatasetJobsApiV1DatasetJobsGet
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListJobsDatasetJobsApiV1DatasetJobsGet
     */
    readonly offset: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListJobsDatasetJobsApiV1DatasetJobsGet
     */
    readonly statuses: string
}

/**
 * Request parameters for listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest
 */
export interface DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet
     */
    readonly flowId?: string | null

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet
     */
    readonly pageSize?: number | null

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet
     */
    readonly pageToken?: string | null
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Add a file to a dataset
     * @param {DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(requestParameters: DefaultApiCreateDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDatasetFileUploadUrlS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdFilePost(requestParameters.s3BucketDatasetId, requestParameters.createFilePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a batch dataset
     * @param {DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(requestParameters: DefaultApiCreateDatasetS3BucketDatasetsApiV1S3BucketDatasetsPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDatasetS3BucketDatasetsApiV1S3BucketDatasetsPost(requestParameters.s3BucketDatasetPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a job
     * @param {DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createJobDatasetJobsApiV1DatasetJobsPost(requestParameters: DefaultApiCreateJobDatasetJobsApiV1DatasetJobsPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createJobDatasetJobsApiV1DatasetJobsPost(requestParameters.body, requestParameters.iceberg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an s3 bucket dataset
     * @param {DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(requestParameters: DefaultApiDeleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteS3BucketDatasetS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdDelete(requestParameters.s3BucketDatasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get job by id
     * @param {DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getJobDatasetJobsApiV1DatasetJobsIdGet(requestParameters: DefaultApiGetJobDatasetJobsApiV1DatasetJobsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getJobDatasetJobsApiV1DatasetJobsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information about a dataset
     * @param {DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(requestParameters: DefaultApiGetS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getS3BucketDatasetDetailS3BucketDatasetsApiV1S3BucketDatasetsS3BucketDatasetIdGet(requestParameters.s3BucketDatasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide a job
     * @param {DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(requestParameters: DefaultApiHideJobDatasetJobsApiV1DatasetJobsIdHidePatchRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).hideJobDatasetJobsApiV1DatasetJobsIdHidePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get jobs for filters
     * @param {DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listJobsDatasetJobsApiV1DatasetJobsGet(requestParameters: DefaultApiListJobsDatasetJobsApiV1DatasetJobsGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listJobsDatasetJobsApiV1DatasetJobsGet(requestParameters.flowId, requestParameters.limit, requestParameters.offset, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all datasets for a flow
     * @param {DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(requestParameters: DefaultApiListS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listS3BucketDatasetsS3BucketDatasetsApiV1S3BucketDatasetsGet(requestParameters.flowId, requestParameters.pageSize, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DestinationsApi - axios parameter creator
 * @export
 */
export const DestinationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a destination
         * @param {string} id 
         * @param {JobDestinationCreateBase} jobDestinationCreateBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobDestinationJobsApiV2JobsIdDestinationsPost: async (id: string, jobDestinationCreateBase: JobDestinationCreateBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createJobDestinationJobsApiV2JobsIdDestinationsPost', 'id', id)
            // verify required parameter 'jobDestinationCreateBase' is not null or undefined
            assertParamExists('createJobDestinationJobsApiV2JobsIdDestinationsPost', 'jobDestinationCreateBase', jobDestinationCreateBase)
            const localVarPath = `/jobs/api/v2/jobs/{id}/destinations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobDestinationCreateBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a destination
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/destinations/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a presigned URL to the final output of the job run
         * @summary Get destination output. Only supported for S3 destinations
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/runs/{id}/output`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get destinations for a job
         * @param {string} jobId 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationsJobsApiV2JobsJobIdDestinationsGet: async (jobId: string, startingAfter?: string | null, limit?: number, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getDestinationsJobsApiV2JobsJobIdDestinationsGet', 'jobId', jobId)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/destinations`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a destination
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobDestinationPatch} jobDestinationPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch: async (jobId: string, id: string, jobDestinationPatch: JobDestinationPatch, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch', 'id', id)
            // verify required parameter 'jobDestinationPatch' is not null or undefined
            assertParamExists('patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch', 'jobDestinationPatch', jobDestinationPatch)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/destinations/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobDestinationPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DestinationsApi - functional programming interface
 * @export
 */
export const DestinationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DestinationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a destination
         * @param {string} id 
         * @param {JobDestinationCreateBase} jobDestinationCreateBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobDestinationJobsApiV2JobsIdDestinationsPost(id: string, jobDestinationCreateBase: JobDestinationCreateBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobDestination>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobDestinationJobsApiV2JobsIdDestinationsPost(id, jobDestinationCreateBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationsApi.createJobDestinationJobsApiV2JobsIdDestinationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a destination
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationsApi.deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a presigned URL to the final output of the job run
         * @summary Get destination output. Only supported for S3 destinations
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRunOutputResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationsApi.getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get destinations for a job
         * @param {string} jobId 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationsJobsApiV2JobsJobIdDestinationsGet(jobId: string, startingAfter?: string | null, limit?: number, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobDestinationPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationsJobsApiV2JobsJobIdDestinationsGet(jobId, startingAfter, limit, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationsApi.getDestinationsJobsApiV2JobsJobIdDestinationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a destination
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobDestinationPatch} jobDestinationPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(jobId: string, id: string, jobDestinationPatch: JobDestinationPatch, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobDestination>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(jobId, id, jobDestinationPatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationsApi.patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DestinationsApi - factory interface
 * @export
 */
export const DestinationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DestinationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a destination
         * @param {DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobDestinationJobsApiV2JobsIdDestinationsPost(requestParameters: DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobDestination> {
            return localVarFp.createJobDestinationJobsApiV2JobsIdDestinationsPost(requestParameters.id, requestParameters.jobDestinationCreateBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a destination
         * @param {DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(requestParameters: DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a presigned URL to the final output of the job run
         * @summary Get destination output. Only supported for S3 destinations
         * @param {DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(requestParameters: DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRunOutputResponse> {
            return localVarFp.getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get destinations for a job
         * @param {DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationsJobsApiV2JobsJobIdDestinationsGet(requestParameters: DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobDestinationPage> {
            return localVarFp.getDestinationsJobsApiV2JobsJobIdDestinationsGet(requestParameters.jobId, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a destination
         * @param {DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(requestParameters: DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobDestination> {
            return localVarFp.patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobDestinationPatch, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createJobDestinationJobsApiV2JobsIdDestinationsPost operation in DestinationsApi.
 * @export
 * @interface DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest
 */
export interface DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPost
     */
    readonly id: string

    /**
     * 
     * @type {JobDestinationCreateBase}
     * @memberof DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPost
     */
    readonly jobDestinationCreateBase: JobDestinationCreateBase
}

/**
 * Request parameters for deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete operation in DestinationsApi.
 * @export
 * @interface DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest
 */
export interface DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet operation in DestinationsApi.
 * @export
 * @interface DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest
 */
export interface DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet
     */
    readonly id: string
}

/**
 * Request parameters for getDestinationsJobsApiV2JobsJobIdDestinationsGet operation in DestinationsApi.
 * @export
 * @interface DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest
 */
export interface DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {number}
     * @memberof DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGet
     */
    readonly pageToken?: string | null
}

/**
 * Request parameters for patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch operation in DestinationsApi.
 * @export
 * @interface DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest
 */
export interface DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatch
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {JobDestinationPatch}
     * @memberof DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatch
     */
    readonly jobDestinationPatch: JobDestinationPatch

    /**
     * 
     * @type {string}
     * @memberof DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * DestinationsApi - object-oriented interface
 * @export
 * @class DestinationsApi
 * @extends {BaseAPI}
 */
export class DestinationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a destination
     * @param {DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public createJobDestinationJobsApiV2JobsIdDestinationsPost(requestParameters: DestinationsApiCreateJobDestinationJobsApiV2JobsIdDestinationsPostRequest, options?: RawAxiosRequestConfig) {
        return DestinationsApiFp(this.configuration).createJobDestinationJobsApiV2JobsIdDestinationsPost(requestParameters.id, requestParameters.jobDestinationCreateBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a destination
     * @param {DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(requestParameters: DestinationsApiDeleteDestinationJobsApiV2JobsJobIdDestinationsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DestinationsApiFp(this.configuration).deleteDestinationJobsApiV2JobsJobIdDestinationsIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a presigned URL to the final output of the job run
     * @summary Get destination output. Only supported for S3 destinations
     * @param {DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(requestParameters: DestinationsApiGetDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGetRequest, options?: RawAxiosRequestConfig) {
        return DestinationsApiFp(this.configuration).getDestinationOutputJobsApiV2JobsJobIdRunsIdOutputGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get destinations for a job
     * @param {DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getDestinationsJobsApiV2JobsJobIdDestinationsGet(requestParameters: DestinationsApiGetDestinationsJobsApiV2JobsJobIdDestinationsGetRequest, options?: RawAxiosRequestConfig) {
        return DestinationsApiFp(this.configuration).getDestinationsJobsApiV2JobsJobIdDestinationsGet(requestParameters.jobId, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a destination
     * @param {DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(requestParameters: DestinationsApiPatchDestinationJobsApiV2JobsJobIdDestinationsIdPatchRequest, options?: RawAxiosRequestConfig) {
        return DestinationsApiFp(this.configuration).patchDestinationJobsApiV2JobsJobIdDestinationsIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobDestinationPatch, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate a job
         * @param {string} id 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateJobJobsApiV1JobsIdActivatePost: async (id: string, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateJobJobsApiV1JobsIdActivatePost', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activate a job
         * @param {string} id 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateJobJobsApiV2JobsIdActivatePost: async (id: string, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateJobJobsApiV2JobsIdActivatePost', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobJobsApiV1JobsPost: async (jobCreate: JobCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobCreate' is not null or undefined
            assertParamExists('createJobJobsApiV1JobsPost', 'jobCreate', jobCreate)
            const localVarPath = `/jobs/api/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobJobsApiV2JobsPost: async (jobCreate: JobCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobCreate' is not null or undefined
            assertParamExists('createJobJobsApiV2JobsPost', 'jobCreate', jobCreate)
            const localVarPath = `/jobs/api/v2/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateJobJobsApiV1JobsIdDeactivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateJobJobsApiV1JobsIdDeactivatePost', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateJobJobsApiV2JobsIdDeactivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateJobJobsApiV2JobsIdDeactivatePost', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobJobsApiV1JobsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobJobsApiV1JobsIdDelete', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobJobsApiV2JobsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobJobsApiV2JobsIdDelete', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {string} id 
         * @param {JobDuplicate} jobDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJobJobsApiV1JobsIdDuplicatePost: async (id: string, jobDuplicate: JobDuplicate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateJobJobsApiV1JobsIdDuplicatePost', 'id', id)
            // verify required parameter 'jobDuplicate' is not null or undefined
            assertParamExists('duplicateJobJobsApiV1JobsIdDuplicatePost', 'jobDuplicate', jobDuplicate)
            const localVarPath = `/jobs/api/v1/jobs/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobDuplicate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {string} id 
         * @param {JobDuplicate} jobDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJobJobsApiV2JobsIdDuplicatePost: async (id: string, jobDuplicate: JobDuplicate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateJobJobsApiV2JobsIdDuplicatePost', 'id', id)
            // verify required parameter 'jobDuplicate' is not null or undefined
            assertParamExists('duplicateJobJobsApiV2JobsIdDuplicatePost', 'jobDuplicate', jobDuplicate)
            const localVarPath = `/jobs/api/v2/jobs/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobDuplicate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobJobsApiV1JobsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobJobsApiV1JobsIdGet', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobJobsApiV2JobsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobJobsApiV2JobsIdGet', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Jobs, without pagination on V1.
         * @summary Get jobs for a flow
         * @param {string} flowId 
         * @param {string | null} [flowVersionId] 
         * @param {JobStatus | null} [status] 
         * @param {boolean | null} [includeSimulations] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsJobsApiV1JobsGet: async (flowId: string, flowVersionId?: string | null, status?: JobStatus | null, includeSimulations?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getJobsJobsApiV1JobsGet', 'flowId', flowId)
            const localVarPath = `/jobs/api/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (flowVersionId !== undefined) {
                localVarQueryParameter['flow_version_id'] = flowVersionId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeSimulations !== undefined) {
                localVarQueryParameter['include_simulations'] = includeSimulations;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get jobs
         * @param {string | null} [startingAfter] 
         * @param {string | null} [runId] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {boolean | null} [includeSimulations] 
         * @param {string | null} [flowIds] 
         * @param {string | null} [flowVersionIds] 
         * @param {string | null} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsJobsApiV2JobsGet: async (startingAfter?: string | null, runId?: string | null, limit?: number, pageToken?: string | null, includeSimulations?: boolean | null, flowIds?: string | null, flowVersionIds?: string | null, statuses?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/jobs/api/v2/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (runId !== undefined) {
                localVarQueryParameter['run_id'] = runId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (includeSimulations !== undefined) {
                localVarQueryParameter['include_simulations'] = includeSimulations;
            }

            if (flowIds !== undefined) {
                localVarQueryParameter['flow_ids'] = flowIds;
            }

            if (flowVersionIds !== undefined) {
                localVarQueryParameter['flow_version_ids'] = flowVersionIds;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job
         * @param {string} id 
         * @param {JobPatch} jobPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobJobsApiV1JobsIdPatch: async (id: string, jobPatch: JobPatch, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchJobJobsApiV1JobsIdPatch', 'id', id)
            // verify required parameter 'jobPatch' is not null or undefined
            assertParamExists('patchJobJobsApiV1JobsIdPatch', 'jobPatch', jobPatch)
            const localVarPath = `/jobs/api/v1/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a job
         * @param {string} id 
         * @param {JobPatch} jobPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobJobsApiV2JobsIdPatch: async (id: string, jobPatch: JobPatch, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchJobJobsApiV2JobsIdPatch', 'id', id)
            // verify required parameter 'jobPatch' is not null or undefined
            assertParamExists('patchJobJobsApiV2JobsIdPatch', 'jobPatch', jobPatch)
            const localVarPath = `/jobs/api/v2/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate a job
         * @param {string} id 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateJobJobsApiV1JobsIdActivatePost(id: string, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateJobJobsApiV1JobsIdActivatePost(id, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.activateJobJobsApiV1JobsIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Activate a job
         * @param {string} id 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateJobJobsApiV2JobsIdActivatePost(id: string, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateJobJobsApiV2JobsIdActivatePost(id, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.activateJobJobsApiV2JobsIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobJobsApiV1JobsPost(jobCreate: JobCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobJobsApiV1JobsPost(jobCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createJobJobsApiV1JobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a job
         * @param {JobCreate} jobCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobJobsApiV2JobsPost(jobCreate: JobCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobJobsApiV2JobsPost(jobCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createJobJobsApiV2JobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateJobJobsApiV1JobsIdDeactivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateJobJobsApiV1JobsIdDeactivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.deactivateJobJobsApiV1JobsIdDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateJobJobsApiV2JobsIdDeactivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateJobJobsApiV2JobsIdDeactivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.deactivateJobJobsApiV2JobsIdDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobJobsApiV1JobsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobJobsApiV1JobsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.deleteJobJobsApiV1JobsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobJobsApiV2JobsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobJobsApiV2JobsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.deleteJobJobsApiV2JobsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {string} id 
         * @param {JobDuplicate} jobDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateJobJobsApiV1JobsIdDuplicatePost(id: string, jobDuplicate: JobDuplicate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateJobJobsApiV1JobsIdDuplicatePost(id, jobDuplicate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.duplicateJobJobsApiV1JobsIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {string} id 
         * @param {JobDuplicate} jobDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateJobJobsApiV2JobsIdDuplicatePost(id: string, jobDuplicate: JobDuplicate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateJobJobsApiV2JobsIdDuplicatePost(id, jobDuplicate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.duplicateJobJobsApiV2JobsIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobJobsApiV1JobsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobJobsApiV1JobsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobJobsApiV1JobsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobJobsApiV2JobsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobJobsApiV2JobsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobJobsApiV2JobsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Jobs, without pagination on V1.
         * @summary Get jobs for a flow
         * @param {string} flowId 
         * @param {string | null} [flowVersionId] 
         * @param {JobStatus | null} [status] 
         * @param {boolean | null} [includeSimulations] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsJobsApiV1JobsGet(flowId: string, flowVersionId?: string | null, status?: JobStatus | null, includeSimulations?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Job>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsJobsApiV1JobsGet(flowId, flowVersionId, status, includeSimulations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobsJobsApiV1JobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get jobs
         * @param {string | null} [startingAfter] 
         * @param {string | null} [runId] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {boolean | null} [includeSimulations] 
         * @param {string | null} [flowIds] 
         * @param {string | null} [flowVersionIds] 
         * @param {string | null} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsJobsApiV2JobsGet(startingAfter?: string | null, runId?: string | null, limit?: number, pageToken?: string | null, includeSimulations?: boolean | null, flowIds?: string | null, flowVersionIds?: string | null, statuses?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsJobsApiV2JobsGet(startingAfter, runId, limit, pageToken, includeSimulations, flowIds, flowVersionIds, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobsJobsApiV2JobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job
         * @param {string} id 
         * @param {JobPatch} jobPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchJobJobsApiV1JobsIdPatch(id: string, jobPatch: JobPatch, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchJobJobsApiV1JobsIdPatch(id, jobPatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.patchJobJobsApiV1JobsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a job
         * @param {string} id 
         * @param {JobPatch} jobPatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchJobJobsApiV2JobsIdPatch(id: string, jobPatch: JobPatch, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchJobJobsApiV2JobsIdPatch(id, jobPatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.patchJobJobsApiV2JobsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate a job
         * @param {JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateJobJobsApiV1JobsIdActivatePost(requestParameters: JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.activateJobJobsApiV1JobsIdActivatePost(requestParameters.id, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activate a job
         * @param {JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateJobJobsApiV2JobsIdActivatePost(requestParameters: JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.activateJobJobsApiV2JobsIdActivatePost(requestParameters.id, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a job
         * @param {JobsApiCreateJobJobsApiV1JobsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobJobsApiV1JobsPost(requestParameters: JobsApiCreateJobJobsApiV1JobsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.createJobJobsApiV1JobsPost(requestParameters.jobCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a job
         * @param {JobsApiCreateJobJobsApiV2JobsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobJobsApiV2JobsPost(requestParameters: JobsApiCreateJobJobsApiV2JobsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.createJobJobsApiV2JobsPost(requestParameters.jobCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateJobJobsApiV1JobsIdDeactivatePost(requestParameters: JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.deactivateJobJobsApiV1JobsIdDeactivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a job
         * @param {JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateJobJobsApiV2JobsIdDeactivatePost(requestParameters: JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.deactivateJobJobsApiV2JobsIdDeactivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job
         * @param {JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobJobsApiV1JobsIdDelete(requestParameters: JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteJobJobsApiV1JobsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a job
         * @param {JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobJobsApiV2JobsIdDelete(requestParameters: JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteJobJobsApiV2JobsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJobJobsApiV1JobsIdDuplicatePost(requestParameters: JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.duplicateJobJobsApiV1JobsIdDuplicatePost(requestParameters.id, requestParameters.jobDuplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate a job
         * @param {JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateJobJobsApiV2JobsIdDuplicatePost(requestParameters: JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.duplicateJobJobsApiV2JobsIdDuplicatePost(requestParameters.id, requestParameters.jobDuplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job
         * @param {JobsApiGetJobJobsApiV1JobsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobJobsApiV1JobsIdGet(requestParameters: JobsApiGetJobJobsApiV1JobsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.getJobJobsApiV1JobsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a job
         * @param {JobsApiGetJobJobsApiV2JobsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobJobsApiV2JobsIdGet(requestParameters: JobsApiGetJobJobsApiV2JobsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.getJobJobsApiV2JobsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Jobs, without pagination on V1.
         * @summary Get jobs for a flow
         * @param {JobsApiGetJobsJobsApiV1JobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsJobsApiV1JobsGet(requestParameters: JobsApiGetJobsJobsApiV1JobsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Job>> {
            return localVarFp.getJobsJobsApiV1JobsGet(requestParameters.flowId, requestParameters.flowVersionId, requestParameters.status, requestParameters.includeSimulations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get jobs
         * @param {JobsApiGetJobsJobsApiV2JobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsJobsApiV2JobsGet(requestParameters: JobsApiGetJobsJobsApiV2JobsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<JobPage> {
            return localVarFp.getJobsJobsApiV2JobsGet(requestParameters.startingAfter, requestParameters.runId, requestParameters.limit, requestParameters.pageToken, requestParameters.includeSimulations, requestParameters.flowIds, requestParameters.flowVersionIds, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job
         * @param {JobsApiPatchJobJobsApiV1JobsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobJobsApiV1JobsIdPatch(requestParameters: JobsApiPatchJobJobsApiV1JobsIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.patchJobJobsApiV1JobsIdPatch(requestParameters.id, requestParameters.jobPatch, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a job
         * @param {JobsApiPatchJobJobsApiV2JobsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobJobsApiV2JobsIdPatch(requestParameters: JobsApiPatchJobJobsApiV2JobsIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.patchJobJobsApiV2JobsIdPatch(requestParameters.id, requestParameters.jobPatch, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateJobJobsApiV1JobsIdActivatePost operation in JobsApi.
 * @export
 * @interface JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest
 */
export interface JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiActivateJobJobsApiV1JobsIdActivatePost
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiActivateJobJobsApiV1JobsIdActivatePost
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for activateJobJobsApiV2JobsIdActivatePost operation in JobsApi.
 * @export
 * @interface JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest
 */
export interface JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiActivateJobJobsApiV2JobsIdActivatePost
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiActivateJobJobsApiV2JobsIdActivatePost
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for createJobJobsApiV1JobsPost operation in JobsApi.
 * @export
 * @interface JobsApiCreateJobJobsApiV1JobsPostRequest
 */
export interface JobsApiCreateJobJobsApiV1JobsPostRequest {
    /**
     * 
     * @type {JobCreate}
     * @memberof JobsApiCreateJobJobsApiV1JobsPost
     */
    readonly jobCreate: JobCreate
}

/**
 * Request parameters for createJobJobsApiV2JobsPost operation in JobsApi.
 * @export
 * @interface JobsApiCreateJobJobsApiV2JobsPostRequest
 */
export interface JobsApiCreateJobJobsApiV2JobsPostRequest {
    /**
     * 
     * @type {JobCreate}
     * @memberof JobsApiCreateJobJobsApiV2JobsPost
     */
    readonly jobCreate: JobCreate
}

/**
 * Request parameters for deactivateJobJobsApiV1JobsIdDeactivatePost operation in JobsApi.
 * @export
 * @interface JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest
 */
export interface JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePost
     */
    readonly id: string
}

/**
 * Request parameters for deactivateJobJobsApiV2JobsIdDeactivatePost operation in JobsApi.
 * @export
 * @interface JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest
 */
export interface JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePost
     */
    readonly id: string
}

/**
 * Request parameters for deleteJobJobsApiV1JobsIdDelete operation in JobsApi.
 * @export
 * @interface JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest
 */
export interface JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDeleteJobJobsApiV1JobsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for deleteJobJobsApiV2JobsIdDelete operation in JobsApi.
 * @export
 * @interface JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest
 */
export interface JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDeleteJobJobsApiV2JobsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for duplicateJobJobsApiV1JobsIdDuplicatePost operation in JobsApi.
 * @export
 * @interface JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest
 */
export interface JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePost
     */
    readonly id: string

    /**
     * 
     * @type {JobDuplicate}
     * @memberof JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePost
     */
    readonly jobDuplicate: JobDuplicate
}

/**
 * Request parameters for duplicateJobJobsApiV2JobsIdDuplicatePost operation in JobsApi.
 * @export
 * @interface JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest
 */
export interface JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePost
     */
    readonly id: string

    /**
     * 
     * @type {JobDuplicate}
     * @memberof JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePost
     */
    readonly jobDuplicate: JobDuplicate
}

/**
 * Request parameters for getJobJobsApiV1JobsIdGet operation in JobsApi.
 * @export
 * @interface JobsApiGetJobJobsApiV1JobsIdGetRequest
 */
export interface JobsApiGetJobJobsApiV1JobsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobJobsApiV1JobsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for getJobJobsApiV2JobsIdGet operation in JobsApi.
 * @export
 * @interface JobsApiGetJobJobsApiV2JobsIdGetRequest
 */
export interface JobsApiGetJobJobsApiV2JobsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobJobsApiV2JobsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for getJobsJobsApiV1JobsGet operation in JobsApi.
 * @export
 * @interface JobsApiGetJobsJobsApiV1JobsGetRequest
 */
export interface JobsApiGetJobsJobsApiV1JobsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV1JobsGet
     */
    readonly flowId: string

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV1JobsGet
     */
    readonly flowVersionId?: string | null

    /**
     * 
     * @type {JobStatus}
     * @memberof JobsApiGetJobsJobsApiV1JobsGet
     */
    readonly status?: JobStatus | null

    /**
     * 
     * @type {boolean}
     * @memberof JobsApiGetJobsJobsApiV1JobsGet
     */
    readonly includeSimulations?: boolean | null
}

/**
 * Request parameters for getJobsJobsApiV2JobsGet operation in JobsApi.
 * @export
 * @interface JobsApiGetJobsJobsApiV2JobsGetRequest
 */
export interface JobsApiGetJobsJobsApiV2JobsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly runId?: string | null

    /**
     * 
     * @type {number}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly includeSimulations?: boolean | null

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly flowIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly flowVersionIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof JobsApiGetJobsJobsApiV2JobsGet
     */
    readonly statuses?: string | null
}

/**
 * Request parameters for patchJobJobsApiV1JobsIdPatch operation in JobsApi.
 * @export
 * @interface JobsApiPatchJobJobsApiV1JobsIdPatchRequest
 */
export interface JobsApiPatchJobJobsApiV1JobsIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiPatchJobJobsApiV1JobsIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {JobPatch}
     * @memberof JobsApiPatchJobJobsApiV1JobsIdPatch
     */
    readonly jobPatch: JobPatch

    /**
     * 
     * @type {string}
     * @memberof JobsApiPatchJobJobsApiV1JobsIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchJobJobsApiV2JobsIdPatch operation in JobsApi.
 * @export
 * @interface JobsApiPatchJobJobsApiV2JobsIdPatchRequest
 */
export interface JobsApiPatchJobJobsApiV2JobsIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof JobsApiPatchJobJobsApiV2JobsIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {JobPatch}
     * @memberof JobsApiPatchJobJobsApiV2JobsIdPatch
     */
    readonly jobPatch: JobPatch

    /**
     * 
     * @type {string}
     * @memberof JobsApiPatchJobJobsApiV2JobsIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary Activate a job
     * @param {JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public activateJobJobsApiV1JobsIdActivatePost(requestParameters: JobsApiActivateJobJobsApiV1JobsIdActivatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).activateJobJobsApiV1JobsIdActivatePost(requestParameters.id, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activate a job
     * @param {JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public activateJobJobsApiV2JobsIdActivatePost(requestParameters: JobsApiActivateJobJobsApiV2JobsIdActivatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).activateJobJobsApiV2JobsIdActivatePost(requestParameters.id, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a job
     * @param {JobsApiCreateJobJobsApiV1JobsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public createJobJobsApiV1JobsPost(requestParameters: JobsApiCreateJobJobsApiV1JobsPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createJobJobsApiV1JobsPost(requestParameters.jobCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a job
     * @param {JobsApiCreateJobJobsApiV2JobsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public createJobJobsApiV2JobsPost(requestParameters: JobsApiCreateJobJobsApiV2JobsPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createJobJobsApiV2JobsPost(requestParameters.jobCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a job
     * @param {JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deactivateJobJobsApiV1JobsIdDeactivatePost(requestParameters: JobsApiDeactivateJobJobsApiV1JobsIdDeactivatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).deactivateJobJobsApiV1JobsIdDeactivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a job
     * @param {JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deactivateJobJobsApiV2JobsIdDeactivatePost(requestParameters: JobsApiDeactivateJobJobsApiV2JobsIdDeactivatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).deactivateJobJobsApiV2JobsIdDeactivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job
     * @param {JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deleteJobJobsApiV1JobsIdDelete(requestParameters: JobsApiDeleteJobJobsApiV1JobsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).deleteJobJobsApiV1JobsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a job
     * @param {JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public deleteJobJobsApiV2JobsIdDelete(requestParameters: JobsApiDeleteJobJobsApiV2JobsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).deleteJobJobsApiV2JobsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate a job
     * @param {JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public duplicateJobJobsApiV1JobsIdDuplicatePost(requestParameters: JobsApiDuplicateJobJobsApiV1JobsIdDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).duplicateJobJobsApiV1JobsIdDuplicatePost(requestParameters.id, requestParameters.jobDuplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate a job
     * @param {JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public duplicateJobJobsApiV2JobsIdDuplicatePost(requestParameters: JobsApiDuplicateJobJobsApiV2JobsIdDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).duplicateJobJobsApiV2JobsIdDuplicatePost(requestParameters.id, requestParameters.jobDuplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job
     * @param {JobsApiGetJobJobsApiV1JobsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobJobsApiV1JobsIdGet(requestParameters: JobsApiGetJobJobsApiV1JobsIdGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobJobsApiV1JobsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a job
     * @param {JobsApiGetJobJobsApiV2JobsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobJobsApiV2JobsIdGet(requestParameters: JobsApiGetJobJobsApiV2JobsIdGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobJobsApiV2JobsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Jobs, without pagination on V1.
     * @summary Get jobs for a flow
     * @param {JobsApiGetJobsJobsApiV1JobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobsJobsApiV1JobsGet(requestParameters: JobsApiGetJobsJobsApiV1JobsGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobsJobsApiV1JobsGet(requestParameters.flowId, requestParameters.flowVersionId, requestParameters.status, requestParameters.includeSimulations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get jobs
     * @param {JobsApiGetJobsJobsApiV2JobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobsJobsApiV2JobsGet(requestParameters: JobsApiGetJobsJobsApiV2JobsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobsJobsApiV2JobsGet(requestParameters.startingAfter, requestParameters.runId, requestParameters.limit, requestParameters.pageToken, requestParameters.includeSimulations, requestParameters.flowIds, requestParameters.flowVersionIds, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job
     * @param {JobsApiPatchJobJobsApiV1JobsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public patchJobJobsApiV1JobsIdPatch(requestParameters: JobsApiPatchJobJobsApiV1JobsIdPatchRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).patchJobJobsApiV1JobsIdPatch(requestParameters.id, requestParameters.jobPatch, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a job
     * @param {JobsApiPatchJobJobsApiV2JobsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public patchJobJobsApiV2JobsIdPatch(requestParameters: JobsApiPatchJobJobsApiV2JobsIdPatchRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).patchJobJobsApiV2JobsIdPatch(requestParameters.id, requestParameters.jobPatch, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RunsApi - axios parameter creator
 * @export
 */
export const RunsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Start a job run
         * @param {string} id 
         * @param {JobRunCreateRequest} jobRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunJobsApiV1JobsIdRunsPost: async (id: string, jobRunCreateRequest: JobRunCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRunJobsApiV1JobsIdRunsPost', 'id', id)
            // verify required parameter 'jobRunCreateRequest' is not null or undefined
            assertParamExists('createRunJobsApiV1JobsIdRunsPost', 'jobRunCreateRequest', jobRunCreateRequest)
            const localVarPath = `/jobs/api/v1/jobs/{id}/runs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobRunCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a job run
         * @param {string} id 
         * @param {JobRunCreateRequest} jobRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunJobsApiV2JobsIdRunsPost: async (id: string, jobRunCreateRequest: JobRunCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRunJobsApiV2JobsIdRunsPost', 'id', id)
            // verify required parameter 'jobRunCreateRequest' is not null or undefined
            assertParamExists('createRunJobsApiV2JobsIdRunsPost', 'jobRunCreateRequest', jobRunCreateRequest)
            const localVarPath = `/jobs/api/v2/jobs/{id}/runs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobRunCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatusJobsApiV1JobsJobIdRunsIdPollGet: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getRunStatusJobsApiV1JobsJobIdRunsIdPollGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRunStatusJobsApiV1JobsJobIdRunsIdPollGet', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/runs/{id}/poll`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatusJobsApiV2JobsJobIdRunsIdPollGet: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getRunStatusJobsApiV2JobsJobIdRunsIdPollGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRunStatusJobsApiV2JobsJobIdRunsIdPollGet', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/runs/{id}/poll`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get runs, without pagination on V1.
         * @summary Get runs for a job
         * @param {string} id 
         * @param {string | null} [before] 
         * @param {string | null} [after] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {DecisionEnvironment | null} [environment] 
         * @param {JobRunStatusType | null} [status] 
         * @param {string | null} [flowVersionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunsForJobJobsApiV1JobsIdRunsGet: async (id: string, before?: string | null, after?: string | null, offset?: number, limit?: number, environment?: DecisionEnvironment | null, status?: JobRunStatusType | null, flowVersionIds?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRunsForJobJobsApiV1JobsIdRunsGet', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}/runs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (before !== undefined) {
                localVarQueryParameter['before'] = (before as any instanceof Date) ?
                    (before as any).toISOString() :
                    before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = (after as any instanceof Date) ?
                    (after as any).toISOString() :
                    after;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (flowVersionIds !== undefined) {
                localVarQueryParameter['flow_version_ids'] = flowVersionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get runs for a job
         * @param {string} jobId 
         * @param {string | null} [startCreatedAt] 
         * @param {string | null} [endCreatedAt] 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {string | null} [environments] 
         * @param {string | null} [statuses] 
         * @param {string | null} [flowVersionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunsForJobJobsApiV2JobsJobIdRunsGet: async (jobId: string, startCreatedAt?: string | null, endCreatedAt?: string | null, startingAfter?: string | null, limit?: number, pageToken?: string | null, environments?: string | null, statuses?: string | null, flowVersionIds?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getRunsForJobJobsApiV2JobsJobIdRunsGet', 'jobId', jobId)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/runs`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startCreatedAt !== undefined) {
                localVarQueryParameter['start_created_at'] = (startCreatedAt as any instanceof Date) ?
                    (startCreatedAt as any).toISOString() :
                    startCreatedAt;
            }

            if (endCreatedAt !== undefined) {
                localVarQueryParameter['end_created_at'] = (endCreatedAt as any instanceof Date) ?
                    (endCreatedAt as any).toISOString() :
                    endCreatedAt;
            }

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (environments !== undefined) {
                localVarQueryParameter['environments'] = environments;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (flowVersionIds !== undefined) {
                localVarQueryParameter['flow_version_ids'] = flowVersionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop a job run
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRunJobsApiV1JobsJobIdRunsIdStopPost: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('stopRunJobsApiV1JobsJobIdRunsIdStopPost', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stopRunJobsApiV1JobsJobIdRunsIdStopPost', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/runs/{id}/stop`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop a job run
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRunJobsApiV2JobsJobIdRunsIdStopPost: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('stopRunJobsApiV2JobsJobIdRunsIdStopPost', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stopRunJobsApiV2JobsJobIdRunsIdStopPost', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/runs/{id}/stop`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunsApi - functional programming interface
 * @export
 */
export const RunsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Start a job run
         * @param {string} id 
         * @param {JobRunCreateRequest} jobRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRunJobsApiV1JobsIdRunsPost(id: string, jobRunCreateRequest: JobRunCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRunJobsApiV1JobsIdRunsPost(id, jobRunCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.createRunJobsApiV1JobsIdRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a job run
         * @param {string} id 
         * @param {JobRunCreateRequest} jobRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRunJobsApiV2JobsIdRunsPost(id: string, jobRunCreateRequest: JobRunCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRunJobsApiV2JobsIdRunsPost(id, jobRunCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.createRunJobsApiV2JobsIdRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.getRunStatusJobsApiV1JobsJobIdRunsIdPollGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.getRunStatusJobsApiV2JobsJobIdRunsIdPollGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get runs, without pagination on V1.
         * @summary Get runs for a job
         * @param {string} id 
         * @param {string | null} [before] 
         * @param {string | null} [after] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {DecisionEnvironment | null} [environment] 
         * @param {JobRunStatusType | null} [status] 
         * @param {string | null} [flowVersionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunsForJobJobsApiV1JobsIdRunsGet(id: string, before?: string | null, after?: string | null, offset?: number, limit?: number, environment?: DecisionEnvironment | null, status?: JobRunStatusType | null, flowVersionIds?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobRun>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunsForJobJobsApiV1JobsIdRunsGet(id, before, after, offset, limit, environment, status, flowVersionIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.getRunsForJobJobsApiV1JobsIdRunsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get runs for a job
         * @param {string} jobId 
         * @param {string | null} [startCreatedAt] 
         * @param {string | null} [endCreatedAt] 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {string | null} [environments] 
         * @param {string | null} [statuses] 
         * @param {string | null} [flowVersionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunsForJobJobsApiV2JobsJobIdRunsGet(jobId: string, startCreatedAt?: string | null, endCreatedAt?: string | null, startingAfter?: string | null, limit?: number, pageToken?: string | null, environments?: string | null, statuses?: string | null, flowVersionIds?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRunPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunsForJobJobsApiV2JobsJobIdRunsGet(jobId, startCreatedAt, endCreatedAt, startingAfter, limit, pageToken, environments, statuses, flowVersionIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.getRunsForJobJobsApiV2JobsJobIdRunsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop a job run
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopRunJobsApiV1JobsJobIdRunsIdStopPost(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopRunJobsApiV1JobsJobIdRunsIdStopPost(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.stopRunJobsApiV1JobsJobIdRunsIdStopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop a job run
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopRunJobsApiV2JobsJobIdRunsIdStopPost(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopRunJobsApiV2JobsJobIdRunsIdStopPost(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunsApi.stopRunJobsApiV2JobsJobIdRunsIdStopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunsApi - factory interface
 * @export
 */
export const RunsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunsApiFp(configuration)
    return {
        /**
         * 
         * @summary Start a job run
         * @param {RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunJobsApiV1JobsIdRunsPost(requestParameters: RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRun> {
            return localVarFp.createRunJobsApiV1JobsIdRunsPost(requestParameters.id, requestParameters.jobRunCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a job run
         * @param {RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunJobsApiV2JobsIdRunsPost(requestParameters: RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRun> {
            return localVarFp.createRunJobsApiV2JobsIdRunsPost(requestParameters.id, requestParameters.jobRunCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(requestParameters: RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRun> {
            return localVarFp.getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll for job run status
         * @param {RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(requestParameters: RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRun> {
            return localVarFp.getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get runs, without pagination on V1.
         * @summary Get runs for a job
         * @param {RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunsForJobJobsApiV1JobsIdRunsGet(requestParameters: RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobRun>> {
            return localVarFp.getRunsForJobJobsApiV1JobsIdRunsGet(requestParameters.id, requestParameters.before, requestParameters.after, requestParameters.offset, requestParameters.limit, requestParameters.environment, requestParameters.status, requestParameters.flowVersionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get runs for a job
         * @param {RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunsForJobJobsApiV2JobsJobIdRunsGet(requestParameters: RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobRunPage> {
            return localVarFp.getRunsForJobJobsApiV2JobsJobIdRunsGet(requestParameters.jobId, requestParameters.startCreatedAt, requestParameters.endCreatedAt, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, requestParameters.environments, requestParameters.statuses, requestParameters.flowVersionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop a job run
         * @param {RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRunJobsApiV1JobsJobIdRunsIdStopPost(requestParameters: RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.stopRunJobsApiV1JobsJobIdRunsIdStopPost(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop a job run
         * @param {RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopRunJobsApiV2JobsJobIdRunsIdStopPost(requestParameters: RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.stopRunJobsApiV2JobsJobIdRunsIdStopPost(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createRunJobsApiV1JobsIdRunsPost operation in RunsApi.
 * @export
 * @interface RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest
 */
export interface RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiCreateRunJobsApiV1JobsIdRunsPost
     */
    readonly id: string

    /**
     * 
     * @type {JobRunCreateRequest}
     * @memberof RunsApiCreateRunJobsApiV1JobsIdRunsPost
     */
    readonly jobRunCreateRequest: JobRunCreateRequest
}

/**
 * Request parameters for createRunJobsApiV2JobsIdRunsPost operation in RunsApi.
 * @export
 * @interface RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest
 */
export interface RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiCreateRunJobsApiV2JobsIdRunsPost
     */
    readonly id: string

    /**
     * 
     * @type {JobRunCreateRequest}
     * @memberof RunsApiCreateRunJobsApiV2JobsIdRunsPost
     */
    readonly jobRunCreateRequest: JobRunCreateRequest
}

/**
 * Request parameters for getRunStatusJobsApiV1JobsJobIdRunsIdPollGet operation in RunsApi.
 * @export
 * @interface RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest
 */
export interface RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGet
     */
    readonly id: string
}

/**
 * Request parameters for getRunStatusJobsApiV2JobsJobIdRunsIdPollGet operation in RunsApi.
 * @export
 * @interface RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest
 */
export interface RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGet
     */
    readonly id: string
}

/**
 * Request parameters for getRunsForJobJobsApiV1JobsIdRunsGet operation in RunsApi.
 * @export
 * @interface RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest
 */
export interface RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly before?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly after?: string | null

    /**
     * 
     * @type {number}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly environment?: DecisionEnvironment | null

    /**
     * 
     * @type {JobRunStatusType}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly status?: JobRunStatusType | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV1JobsIdRunsGet
     */
    readonly flowVersionIds?: string | null
}

/**
 * Request parameters for getRunsForJobJobsApiV2JobsJobIdRunsGet operation in RunsApi.
 * @export
 * @interface RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest
 */
export interface RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly startCreatedAt?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly endCreatedAt?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {number}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly environments?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly statuses?: string | null

    /**
     * 
     * @type {string}
     * @memberof RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGet
     */
    readonly flowVersionIds?: string | null
}

/**
 * Request parameters for stopRunJobsApiV1JobsJobIdRunsIdStopPost operation in RunsApi.
 * @export
 * @interface RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest
 */
export interface RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPost
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPost
     */
    readonly id: string
}

/**
 * Request parameters for stopRunJobsApiV2JobsJobIdRunsIdStopPost operation in RunsApi.
 * @export
 * @interface RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest
 */
export interface RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPost
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPost
     */
    readonly id: string
}

/**
 * RunsApi - object-oriented interface
 * @export
 * @class RunsApi
 * @extends {BaseAPI}
 */
export class RunsApi extends BaseAPI {
    /**
     * 
     * @summary Start a job run
     * @param {RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public createRunJobsApiV1JobsIdRunsPost(requestParameters: RunsApiCreateRunJobsApiV1JobsIdRunsPostRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).createRunJobsApiV1JobsIdRunsPost(requestParameters.id, requestParameters.jobRunCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a job run
     * @param {RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public createRunJobsApiV2JobsIdRunsPost(requestParameters: RunsApiCreateRunJobsApiV2JobsIdRunsPostRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).createRunJobsApiV2JobsIdRunsPost(requestParameters.id, requestParameters.jobRunCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll for job run status
     * @param {RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(requestParameters: RunsApiGetRunStatusJobsApiV1JobsJobIdRunsIdPollGetRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).getRunStatusJobsApiV1JobsJobIdRunsIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll for job run status
     * @param {RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(requestParameters: RunsApiGetRunStatusJobsApiV2JobsJobIdRunsIdPollGetRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).getRunStatusJobsApiV2JobsJobIdRunsIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get runs, without pagination on V1.
     * @summary Get runs for a job
     * @param {RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public getRunsForJobJobsApiV1JobsIdRunsGet(requestParameters: RunsApiGetRunsForJobJobsApiV1JobsIdRunsGetRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).getRunsForJobJobsApiV1JobsIdRunsGet(requestParameters.id, requestParameters.before, requestParameters.after, requestParameters.offset, requestParameters.limit, requestParameters.environment, requestParameters.status, requestParameters.flowVersionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get runs for a job
     * @param {RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public getRunsForJobJobsApiV2JobsJobIdRunsGet(requestParameters: RunsApiGetRunsForJobJobsApiV2JobsJobIdRunsGetRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).getRunsForJobJobsApiV2JobsJobIdRunsGet(requestParameters.jobId, requestParameters.startCreatedAt, requestParameters.endCreatedAt, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, requestParameters.environments, requestParameters.statuses, requestParameters.flowVersionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop a job run
     * @param {RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public stopRunJobsApiV1JobsJobIdRunsIdStopPost(requestParameters: RunsApiStopRunJobsApiV1JobsJobIdRunsIdStopPostRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).stopRunJobsApiV1JobsJobIdRunsIdStopPost(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop a job run
     * @param {RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    public stopRunJobsApiV2JobsJobIdRunsIdStopPost(requestParameters: RunsApiStopRunJobsApiV2JobsJobIdRunsIdStopPostRequest, options?: RawAxiosRequestConfig) {
        return RunsApiFp(this.configuration).stopRunJobsApiV2JobsJobIdRunsIdStopPost(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SourcesApi - axios parameter creator
 * @export
 */
export const SourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a source
         * @param {string} id 
         * @param {JobSourceCreate} jobSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobSourceJobsApiV1JobsIdSourcesPost: async (id: string, jobSourceCreate: JobSourceCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createJobSourceJobsApiV1JobsIdSourcesPost', 'id', id)
            // verify required parameter 'jobSourceCreate' is not null or undefined
            assertParamExists('createJobSourceJobsApiV1JobsIdSourcesPost', 'jobSourceCreate', jobSourceCreate)
            const localVarPath = `/jobs/api/v1/jobs/{id}/sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobSourceCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a source
         * @param {string} id 
         * @param {JobSourceCreate} jobSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobSourceJobsApiV2JobsIdSourcesPost: async (id: string, jobSourceCreate: JobSourceCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createJobSourceJobsApiV2JobsIdSourcesPost', 'id', id)
            // verify required parameter 'jobSourceCreate' is not null or undefined
            assertParamExists('createJobSourceJobsApiV2JobsIdSourcesPost', 'jobSourceCreate', jobSourceCreate)
            const localVarPath = `/jobs/api/v2/jobs/{id}/sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobSourceCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {string} jobId 
         * @param {CreateJobSourceFromJobRunDatasetJobCreation} createJobSourceFromJobRunDatasetJobCreation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost: async (jobId: string, createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost', 'jobId', jobId)
            // verify required parameter 'createJobSourceFromJobRunDatasetJobCreation' is not null or undefined
            assertParamExists('createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost', 'createJobSourceFromJobRunDatasetJobCreation', createJobSourceFromJobRunDatasetJobCreation)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/async_sources`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobSourceFromJobRunDatasetJobCreation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {string} jobId 
         * @param {CreateJobSourceFromJobRunDatasetJobCreation} createJobSourceFromJobRunDatasetJobCreation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost: async (jobId: string, createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost', 'jobId', jobId)
            // verify required parameter 'createJobSourceFromJobRunDatasetJobCreation' is not null or undefined
            assertParamExists('createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost', 'createJobSourceFromJobRunDatasetJobCreation', createJobSourceFromJobRunDatasetJobCreation)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/async_sources`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobSourceFromJobRunDatasetJobCreation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceJobsApiV1JobsJobIdSourcesIdDelete: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('deleteSourceJobsApiV1JobsJobIdSourcesIdDelete', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSourceJobsApiV1JobsJobIdSourcesIdDelete', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/sources/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceJobsApiV2JobsJobIdSourcesIdDelete: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('deleteSourceJobsApiV2JobsJobIdSourcesIdDelete', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSourceJobsApiV2JobsJobIdSourcesIdDelete', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/sources/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {EntitiesSourcePreviewRequest} entitiesSourcePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost: async (jobId: string, id: string, entitiesSourcePreviewRequest: EntitiesSourcePreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost', 'id', id)
            // verify required parameter 'entitiesSourcePreviewRequest' is not null or undefined
            assertParamExists('entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost', 'entitiesSourcePreviewRequest', entitiesSourcePreviewRequest)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/sources/{id}/preview`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitiesSourcePreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the count of entities in the job source
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountJobsApiV2EntitiesCountExecutionIdGet: async (executionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getEntityCountJobsApiV2EntitiesCountExecutionIdGet', 'executionId', executionId)
            const localVarPath = `/jobs/api/v2/entities/count/{execution_id}`
                .replace(`{${"execution_id"}}`, encodeURIComponent(String(executionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the preview of the source
         * @param {string} jobId 
         * @param {string} id 
         * @param {string} executionId 
         * @param {DecisionEnvironment} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet: async (jobId: string, id: string, executionId: string, environment: DecisionEnvironment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet', 'id', id)
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet', 'executionId', executionId)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet', 'environment', environment)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/{environment}/sources/{id}/preview/{execution_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"execution_id"}}`, encodeURIComponent(String(executionId)))
                .replace(`{${"environment"}}`, encodeURIComponent(String(environment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Sources, without pagination on V1.
         * @summary Get sources for a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesJobsApiV1JobsIdSourcesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSourcesJobsApiV1JobsIdSourcesGet', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{id}/sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sources for a job
         * @param {string} jobId 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesJobsApiV2JobsJobIdSourcesGet: async (jobId: string, startingAfter?: string | null, limit?: number, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getSourcesJobsApiV2JobsJobIdSourcesGet', 'jobId', jobId)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/sources`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobSourcePatch} jobSourcePatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSourceJobsApiV1JobsJobIdSourcesIdPatch: async (jobId: string, id: string, jobSourcePatch: JobSourcePatch, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('patchSourceJobsApiV1JobsJobIdSourcesIdPatch', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchSourceJobsApiV1JobsJobIdSourcesIdPatch', 'id', id)
            // verify required parameter 'jobSourcePatch' is not null or undefined
            assertParamExists('patchSourceJobsApiV1JobsJobIdSourcesIdPatch', 'jobSourcePatch', jobSourcePatch)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/sources/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobSourcePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobSourcePatch} jobSourcePatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSourceJobsApiV2JobsJobIdSourcesIdPatch: async (jobId: string, id: string, jobSourcePatch: JobSourcePatch, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('patchSourceJobsApiV2JobsJobIdSourcesIdPatch', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchSourceJobsApiV2JobsJobIdSourcesIdPatch', 'id', id)
            // verify required parameter 'jobSourcePatch' is not null or undefined
            assertParamExists('patchSourceJobsApiV2JobsJobIdSourcesIdPatch', 'jobSourcePatch', jobSourcePatch)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/sources/{id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobSourcePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet', 'id', id)
            const localVarPath = `/jobs/api/v1/jobs/{job_id}/async_sources/{id}/poll`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet: async (jobId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet', 'jobId', jobId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet', 'id', id)
            const localVarPath = `/jobs/api/v2/jobs/{job_id}/async_sources/{id}/poll`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} id 
         * @param {PreviewQueryRequest} previewQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSourceJobsApiV1JobsIdSourcePreviewPost: async (id: string, previewQueryRequest: PreviewQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewSourceJobsApiV1JobsIdSourcePreviewPost', 'id', id)
            // verify required parameter 'previewQueryRequest' is not null or undefined
            assertParamExists('previewSourceJobsApiV1JobsIdSourcePreviewPost', 'previewQueryRequest', previewQueryRequest)
            const localVarPath = `/jobs/api/v1/jobs/{id}/source_preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} id 
         * @param {PreviewQueryRequest} previewQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSourceJobsApiV2JobsIdSourcePreviewPost: async (id: string, previewQueryRequest: PreviewQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewSourceJobsApiV2JobsIdSourcePreviewPost', 'id', id)
            // verify required parameter 'previewQueryRequest' is not null or undefined
            assertParamExists('previewSourceJobsApiV2JobsIdSourcePreviewPost', 'previewQueryRequest', previewQueryRequest)
            const localVarPath = `/jobs/api/v2/jobs/{id}/source_preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start counting the number of entities in the job source
         * @param {StartEntityCountRequest} startEntityCountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEntityCountJobsApiV2EntitiesCountPost: async (startEntityCountRequest: StartEntityCountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startEntityCountRequest' is not null or undefined
            assertParamExists('startEntityCountJobsApiV2EntitiesCountPost', 'startEntityCountRequest', startEntityCountRequest)
            const localVarPath = `/jobs/api/v2/entities/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startEntityCountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourcesApi - functional programming interface
 * @export
 */
export const SourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a source
         * @param {string} id 
         * @param {JobSourceCreate} jobSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobSourceJobsApiV1JobsIdSourcesPost(id: string, jobSourceCreate: JobSourceCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobSourceJobsApiV1JobsIdSourcesPost(id, jobSourceCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.createJobSourceJobsApiV1JobsIdSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a source
         * @param {string} id 
         * @param {JobSourceCreate} jobSourceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobSourceJobsApiV2JobsIdSourcesPost(id: string, jobSourceCreate: JobSourceCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobSourceJobsApiV2JobsIdSourcesPost(id, jobSourceCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.createJobSourceJobsApiV2JobsIdSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {string} jobId 
         * @param {CreateJobSourceFromJobRunDatasetJobCreation} createJobSourceFromJobRunDatasetJobCreation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(jobId: string, createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobSourceFromJobRunDatasetJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(jobId, createJobSourceFromJobRunDatasetJobCreation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {string} jobId 
         * @param {CreateJobSourceFromJobRunDatasetJobCreation} createJobSourceFromJobRunDatasetJobCreation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(jobId: string, createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobSourceFromJobRunDatasetJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(jobId, createJobSourceFromJobRunDatasetJobCreation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.deleteSourceJobsApiV1JobsJobIdSourcesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.deleteSourceJobsApiV2JobsJobIdSourcesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {EntitiesSourcePreviewRequest} entitiesSourcePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(jobId: string, id: string, entitiesSourcePreviewRequest: EntitiesSourcePreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitiesPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(jobId, id, entitiesSourcePreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the count of entities in the job source
         * @param {string} executionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountJobsApiV2EntitiesCountExecutionIdGet(executionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEntityCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountJobsApiV2EntitiesCountExecutionIdGet(executionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.getEntityCountJobsApiV2EntitiesCountExecutionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the preview of the source
         * @param {string} jobId 
         * @param {string} id 
         * @param {string} executionId 
         * @param {DecisionEnvironment} environment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(jobId: string, id: string, executionId: string, environment: DecisionEnvironment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourcePreviewData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(jobId, id, executionId, environment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Sources, without pagination on V1.
         * @summary Get sources for a job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourcesJobsApiV1JobsIdSourcesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourcesJobsApiV1JobsIdSourcesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.getSourcesJobsApiV1JobsIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sources for a job
         * @param {string} jobId 
         * @param {string | null} [startingAfter] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourcesJobsApiV2JobsJobIdSourcesGet(jobId: string, startingAfter?: string | null, limit?: number, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSourcePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourcesJobsApiV2JobsJobIdSourcesGet(jobId, startingAfter, limit, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.getSourcesJobsApiV2JobsJobIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobSourcePatch} jobSourcePatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSourceJobsApiV1JobsJobIdSourcesIdPatch(jobId: string, id: string, jobSourcePatch: JobSourcePatch, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSourceJobsApiV1JobsJobIdSourcesIdPatch(jobId, id, jobSourcePatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.patchSourceJobsApiV1JobsJobIdSourcesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a source
         * @param {string} jobId 
         * @param {string} id 
         * @param {JobSourcePatch} jobSourcePatch 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSourceJobsApiV2JobsJobIdSourcesIdPatch(jobId: string, id: string, jobSourcePatch: JobSourcePatch, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSourceJobsApiV2JobsJobIdSourcesIdPatch(jobId, id, jobSourcePatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.patchSourceJobsApiV2JobsJobIdSourcesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobSourceFromJobRunDatasetJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {string} jobId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(jobId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobSourceFromJobRunDatasetJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(jobId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} id 
         * @param {PreviewQueryRequest} previewQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewSourceJobsApiV1JobsIdSourcePreviewPost(id: string, previewQueryRequest: PreviewQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DBResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewSourceJobsApiV1JobsIdSourcePreviewPost(id, previewQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.previewSourceJobsApiV1JobsIdSourcePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview a source
         * @param {string} id 
         * @param {PreviewQueryRequest} previewQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewSourceJobsApiV2JobsIdSourcePreviewPost(id: string, previewQueryRequest: PreviewQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DBResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewSourceJobsApiV2JobsIdSourcePreviewPost(id, previewQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.previewSourceJobsApiV2JobsIdSourcePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start counting the number of entities in the job source
         * @param {StartEntityCountRequest} startEntityCountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startEntityCountJobsApiV2EntitiesCountPost(startEntityCountRequest: StartEntityCountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEntityCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startEntityCountJobsApiV2EntitiesCountPost(startEntityCountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.startEntityCountJobsApiV2EntitiesCountPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SourcesApi - factory interface
 * @export
 */
export const SourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourcesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a source
         * @param {SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobSourceJobsApiV1JobsIdSourcesPost(requestParameters: SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSource> {
            return localVarFp.createJobSourceJobsApiV1JobsIdSourcesPost(requestParameters.id, requestParameters.jobSourceCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a source
         * @param {SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobSourceJobsApiV2JobsIdSourcesPost(requestParameters: SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSource> {
            return localVarFp.createJobSourceJobsApiV2JobsIdSourcesPost(requestParameters.id, requestParameters.jobSourceCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(requestParameters: SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobSourceFromJobRunDatasetJob> {
            return localVarFp.createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(requestParameters.jobId, requestParameters.createJobSourceFromJobRunDatasetJobCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Source From Failed Rows
         * @param {SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(requestParameters: SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobSourceFromJobRunDatasetJob> {
            return localVarFp.createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(requestParameters.jobId, requestParameters.createJobSourceFromJobRunDatasetJobCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a source
         * @param {SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(requestParameters: SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a source
         * @param {SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(requestParameters: SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview a source
         * @param {SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(requestParameters: SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntitiesPreviewResponse> {
            return localVarFp.entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(requestParameters.jobId, requestParameters.id, requestParameters.entitiesSourcePreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the count of entities in the job source
         * @param {SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountJobsApiV2EntitiesCountExecutionIdGet(requestParameters: SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEntityCountResponse> {
            return localVarFp.getEntityCountJobsApiV2EntitiesCountExecutionIdGet(requestParameters.executionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the preview of the source
         * @param {SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(requestParameters: SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SourcePreviewData> {
            return localVarFp.getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(requestParameters.jobId, requestParameters.id, requestParameters.executionId, requestParameters.environment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Sources, without pagination on V1.
         * @summary Get sources for a job
         * @param {SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesJobsApiV1JobsIdSourcesGet(requestParameters: SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobSource>> {
            return localVarFp.getSourcesJobsApiV1JobsIdSourcesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sources for a job
         * @param {SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourcesJobsApiV2JobsJobIdSourcesGet(requestParameters: SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSourcePage> {
            return localVarFp.getSourcesJobsApiV2JobsJobIdSourcesGet(requestParameters.jobId, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a source
         * @param {SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSourceJobsApiV1JobsJobIdSourcesIdPatch(requestParameters: SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSource> {
            return localVarFp.patchSourceJobsApiV1JobsJobIdSourcesIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobSourcePatch, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a source
         * @param {SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSourceJobsApiV2JobsJobIdSourcesIdPatch(requestParameters: SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSource> {
            return localVarFp.patchSourceJobsApiV2JobsJobIdSourcesIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobSourcePatch, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(requestParameters: SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobSourceFromJobRunDatasetJob> {
            return localVarFp.pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Used for polling async dataset jobs for job source creation
         * @summary Poll Dataset Jobs
         * @param {SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(requestParameters: SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobSourceFromJobRunDatasetJob> {
            return localVarFp.pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview a source
         * @param {SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSourceJobsApiV1JobsIdSourcePreviewPost(requestParameters: SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DBResponse> {
            return localVarFp.previewSourceJobsApiV1JobsIdSourcePreviewPost(requestParameters.id, requestParameters.previewQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview a source
         * @param {SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewSourceJobsApiV2JobsIdSourcePreviewPost(requestParameters: SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DBResponse> {
            return localVarFp.previewSourceJobsApiV2JobsIdSourcePreviewPost(requestParameters.id, requestParameters.previewQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start counting the number of entities in the job source
         * @param {SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEntityCountJobsApiV2EntitiesCountPost(requestParameters: SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartEntityCountResponse> {
            return localVarFp.startEntityCountJobsApiV2EntitiesCountPost(requestParameters.startEntityCountRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createJobSourceJobsApiV1JobsIdSourcesPost operation in SourcesApi.
 * @export
 * @interface SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest
 */
export interface SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPost
     */
    readonly id: string

    /**
     * 
     * @type {JobSourceCreate}
     * @memberof SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPost
     */
    readonly jobSourceCreate: JobSourceCreate
}

/**
 * Request parameters for createJobSourceJobsApiV2JobsIdSourcesPost operation in SourcesApi.
 * @export
 * @interface SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest
 */
export interface SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPost
     */
    readonly id: string

    /**
     * 
     * @type {JobSourceCreate}
     * @memberof SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPost
     */
    readonly jobSourceCreate: JobSourceCreate
}

/**
 * Request parameters for createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost operation in SourcesApi.
 * @export
 * @interface SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest
 */
export interface SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost
     */
    readonly jobId: string

    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobCreation}
     * @memberof SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost
     */
    readonly createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation
}

/**
 * Request parameters for createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost operation in SourcesApi.
 * @export
 * @interface SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest
 */
export interface SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost
     */
    readonly jobId: string

    /**
     * 
     * @type {CreateJobSourceFromJobRunDatasetJobCreation}
     * @memberof SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost
     */
    readonly createJobSourceFromJobRunDatasetJobCreation: CreateJobSourceFromJobRunDatasetJobCreation
}

/**
 * Request parameters for deleteSourceJobsApiV1JobsJobIdSourcesIdDelete operation in SourcesApi.
 * @export
 * @interface SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest
 */
export interface SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDelete
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for deleteSourceJobsApiV2JobsJobIdSourcesIdDelete operation in SourcesApi.
 * @export
 * @interface SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest
 */
export interface SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDelete
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost operation in SourcesApi.
 * @export
 * @interface SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest
 */
export interface SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost
     */
    readonly id: string

    /**
     * 
     * @type {EntitiesSourcePreviewRequest}
     * @memberof SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost
     */
    readonly entitiesSourcePreviewRequest: EntitiesSourcePreviewRequest
}

/**
 * Request parameters for getEntityCountJobsApiV2EntitiesCountExecutionIdGet operation in SourcesApi.
 * @export
 * @interface SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest
 */
export interface SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGet
     */
    readonly executionId: string
}

/**
 * Request parameters for getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet operation in SourcesApi.
 * @export
 * @interface SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest
 */
export interface SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet
     */
    readonly executionId: string

    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet
     */
    readonly environment: DecisionEnvironment
}

/**
 * Request parameters for getSourcesJobsApiV1JobsIdSourcesGet operation in SourcesApi.
 * @export
 * @interface SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest
 */
export interface SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetSourcesJobsApiV1JobsIdSourcesGet
     */
    readonly id: string
}

/**
 * Request parameters for getSourcesJobsApiV2JobsJobIdSourcesGet operation in SourcesApi.
 * @export
 * @interface SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest
 */
export interface SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {number}
     * @memberof SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGet
     */
    readonly pageToken?: string | null
}

/**
 * Request parameters for patchSourceJobsApiV1JobsJobIdSourcesIdPatch operation in SourcesApi.
 * @export
 * @interface SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest
 */
export interface SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatch
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {JobSourcePatch}
     * @memberof SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatch
     */
    readonly jobSourcePatch: JobSourcePatch

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchSourceJobsApiV2JobsJobIdSourcesIdPatch operation in SourcesApi.
 * @export
 * @interface SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest
 */
export interface SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatch
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {JobSourcePatch}
     * @memberof SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatch
     */
    readonly jobSourcePatch: JobSourcePatch

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet operation in SourcesApi.
 * @export
 * @interface SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest
 */
export interface SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet
     */
    readonly id: string
}

/**
 * Request parameters for pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet operation in SourcesApi.
 * @export
 * @interface SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest
 */
export interface SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet
     */
    readonly jobId: string

    /**
     * 
     * @type {string}
     * @memberof SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet
     */
    readonly id: string
}

/**
 * Request parameters for previewSourceJobsApiV1JobsIdSourcePreviewPost operation in SourcesApi.
 * @export
 * @interface SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest
 */
export interface SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPost
     */
    readonly id: string

    /**
     * 
     * @type {PreviewQueryRequest}
     * @memberof SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPost
     */
    readonly previewQueryRequest: PreviewQueryRequest
}

/**
 * Request parameters for previewSourceJobsApiV2JobsIdSourcePreviewPost operation in SourcesApi.
 * @export
 * @interface SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest
 */
export interface SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPost
     */
    readonly id: string

    /**
     * 
     * @type {PreviewQueryRequest}
     * @memberof SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPost
     */
    readonly previewQueryRequest: PreviewQueryRequest
}

/**
 * Request parameters for startEntityCountJobsApiV2EntitiesCountPost operation in SourcesApi.
 * @export
 * @interface SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest
 */
export interface SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest {
    /**
     * 
     * @type {StartEntityCountRequest}
     * @memberof SourcesApiStartEntityCountJobsApiV2EntitiesCountPost
     */
    readonly startEntityCountRequest: StartEntityCountRequest
}

/**
 * SourcesApi - object-oriented interface
 * @export
 * @class SourcesApi
 * @extends {BaseAPI}
 */
export class SourcesApi extends BaseAPI {
    /**
     * 
     * @summary Create a source
     * @param {SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public createJobSourceJobsApiV1JobsIdSourcesPost(requestParameters: SourcesApiCreateJobSourceJobsApiV1JobsIdSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).createJobSourceJobsApiV1JobsIdSourcesPost(requestParameters.id, requestParameters.jobSourceCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a source
     * @param {SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public createJobSourceJobsApiV2JobsIdSourcesPost(requestParameters: SourcesApiCreateJobSourceJobsApiV2JobsIdSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).createJobSourceJobsApiV2JobsIdSourcesPost(requestParameters.id, requestParameters.jobSourceCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Source From Failed Rows
     * @param {SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(requestParameters: SourcesApiCreateSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).createSourceFromFailedRowsJobsApiV1JobsJobIdAsyncSourcesPost(requestParameters.jobId, requestParameters.createJobSourceFromJobRunDatasetJobCreation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Source From Failed Rows
     * @param {SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(requestParameters: SourcesApiCreateSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).createSourceFromFailedRowsJobsApiV2JobsJobIdAsyncSourcesPost(requestParameters.jobId, requestParameters.createJobSourceFromJobRunDatasetJobCreation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a source
     * @param {SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(requestParameters: SourcesApiDeleteSourceJobsApiV1JobsJobIdSourcesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).deleteSourceJobsApiV1JobsJobIdSourcesIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a source
     * @param {SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(requestParameters: SourcesApiDeleteSourceJobsApiV2JobsJobIdSourcesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).deleteSourceJobsApiV2JobsJobIdSourcesIdDelete(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview a source
     * @param {SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(requestParameters: SourcesApiEntitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).entitiesPreviewSourceJobsApiV2JobsJobIdSourcesIdPreviewPost(requestParameters.jobId, requestParameters.id, requestParameters.entitiesSourcePreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the count of entities in the job source
     * @param {SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public getEntityCountJobsApiV2EntitiesCountExecutionIdGet(requestParameters: SourcesApiGetEntityCountJobsApiV2EntitiesCountExecutionIdGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).getEntityCountJobsApiV2EntitiesCountExecutionIdGet(requestParameters.executionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the preview of the source
     * @param {SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(requestParameters: SourcesApiGetPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).getPreviewForSourceJobsApiV2JobsJobIdEnvironmentSourcesIdPreviewExecutionIdGet(requestParameters.jobId, requestParameters.id, requestParameters.executionId, requestParameters.environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Sources, without pagination on V1.
     * @summary Get sources for a job
     * @param {SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public getSourcesJobsApiV1JobsIdSourcesGet(requestParameters: SourcesApiGetSourcesJobsApiV1JobsIdSourcesGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).getSourcesJobsApiV1JobsIdSourcesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sources for a job
     * @param {SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public getSourcesJobsApiV2JobsJobIdSourcesGet(requestParameters: SourcesApiGetSourcesJobsApiV2JobsJobIdSourcesGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).getSourcesJobsApiV2JobsJobIdSourcesGet(requestParameters.jobId, requestParameters.startingAfter, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a source
     * @param {SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public patchSourceJobsApiV1JobsJobIdSourcesIdPatch(requestParameters: SourcesApiPatchSourceJobsApiV1JobsJobIdSourcesIdPatchRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).patchSourceJobsApiV1JobsJobIdSourcesIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobSourcePatch, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a source
     * @param {SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public patchSourceJobsApiV2JobsJobIdSourcesIdPatch(requestParameters: SourcesApiPatchSourceJobsApiV2JobsJobIdSourcesIdPatchRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).patchSourceJobsApiV2JobsJobIdSourcesIdPatch(requestParameters.jobId, requestParameters.id, requestParameters.jobSourcePatch, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used for polling async dataset jobs for job source creation
     * @summary Poll Dataset Jobs
     * @param {SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(requestParameters: SourcesApiPollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).pollDatasetJobsJobsApiV1JobsJobIdAsyncSourcesIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used for polling async dataset jobs for job source creation
     * @summary Poll Dataset Jobs
     * @param {SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(requestParameters: SourcesApiPollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGetRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).pollDatasetJobsJobsApiV2JobsJobIdAsyncSourcesIdPollGet(requestParameters.jobId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview a source
     * @param {SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public previewSourceJobsApiV1JobsIdSourcePreviewPost(requestParameters: SourcesApiPreviewSourceJobsApiV1JobsIdSourcePreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).previewSourceJobsApiV1JobsIdSourcePreviewPost(requestParameters.id, requestParameters.previewQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview a source
     * @param {SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public previewSourceJobsApiV2JobsIdSourcePreviewPost(requestParameters: SourcesApiPreviewSourceJobsApiV2JobsIdSourcePreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).previewSourceJobsApiV2JobsIdSourcePreviewPost(requestParameters.id, requestParameters.previewQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start counting the number of entities in the job source
     * @param {SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourcesApi
     */
    public startEntityCountJobsApiV2EntitiesCountPost(requestParameters: SourcesApiStartEntityCountJobsApiV2EntitiesCountPostRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).startEntityCountJobsApiV2EntitiesCountPost(requestParameters.startEntityCountRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrafficPoliciesApi - axios parameter creator
 * @export
 */
export const TrafficPoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a traffic policy and make it the active one for the Job
         * @param {string} id 
         * @param {JobTrafficPolicyCreate} jobTrafficPolicyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost: async (id: string, jobTrafficPolicyCreate: JobTrafficPolicyCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost', 'id', id)
            // verify required parameter 'jobTrafficPolicyCreate' is not null or undefined
            assertParamExists('createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost', 'jobTrafficPolicyCreate', jobTrafficPolicyCreate)
            const localVarPath = `/jobs/api/v2/jobs/{id}/traffic_policies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobTrafficPolicyCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrafficPoliciesApi - functional programming interface
 * @export
 */
export const TrafficPoliciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrafficPoliciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a traffic policy and make it the active one for the Job
         * @param {string} id 
         * @param {JobTrafficPolicyCreate} jobTrafficPolicyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(id: string, jobTrafficPolicyCreate: JobTrafficPolicyCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(id, jobTrafficPolicyCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrafficPoliciesApi.createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrafficPoliciesApi - factory interface
 * @export
 */
export const TrafficPoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrafficPoliciesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a traffic policy and make it the active one for the Job
         * @param {TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(requestParameters: TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(requestParameters.id, requestParameters.jobTrafficPolicyCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost operation in TrafficPoliciesApi.
 * @export
 * @interface TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest
 */
export interface TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost
     */
    readonly id: string

    /**
     * 
     * @type {JobTrafficPolicyCreate}
     * @memberof TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost
     */
    readonly jobTrafficPolicyCreate: JobTrafficPolicyCreate
}

/**
 * TrafficPoliciesApi - object-oriented interface
 * @export
 * @class TrafficPoliciesApi
 * @extends {BaseAPI}
 */
export class TrafficPoliciesApi extends BaseAPI {
    /**
     * 
     * @summary Create a traffic policy and make it the active one for the Job
     * @param {TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficPoliciesApi
     */
    public createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(requestParameters: TrafficPoliciesApiCreateAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPostRequest, options?: RawAxiosRequestConfig) {
        return TrafficPoliciesApiFp(this.configuration).createAndActivateTrafficPolicyJobsApiV2JobsIdTrafficPoliciesPost(requestParameters.id, requestParameters.jobTrafficPolicyCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



